/* VanillaGoods My Kitchen dashboard (v2): This week (bake list, bake-along, picks), profile editor and public profile
   preview, bakes, saved lists, Academy, recipes and reviews, markets and events, orders and preferences. Saved lists come
   from window.vgMe (this browser, kept in step with the member's account); profile changes go to the sync service. */
(function () {
  var root = document.querySelector('[data-mk]');
  if (!root || !root.querySelector('.mk-shell')) return;
  var EVENTS_URL = root.getAttribute('data-events-url') || '/pages/vanilla-coffee-tea-events-calendar';
  var ACADEMY_URL = root.getAttribute('data-academy-url') || '/pages/baking-academy';
  var me = window.vgMe || {};
  ['read', 'set', 'onChange'].forEach(function (f) { if (typeof me[f] !== 'function') me[f] = function () { return null; }; });
  if (typeof me.meta !== 'function') me.meta = function () { return {}; };
  if (typeof me.activity !== 'function') me.activity = function () { return {}; };
  if (typeof me.profile !== 'function') me.profile = function () { return {}; };
  var K = { recipes: 'vg_blog_favs', markets: 'vg_fm_favorites_v1', events: 'vg_events_saved_v1', saved: 'vga-saved-v1',
            progress: 'vga-progress-v1', products: 'vg_products_saved_v1', books: 'vg_books_saved_v1', bakes: 'vg_bakes_v1',
            plan: 'vg_plan_v1', tools: 'vg_tools_saved_v1', desserts: 'vg_desserts_v1', baskets: 'vg_baskets_v1', bakebudget: 'vg_bakebudget_v1' };
  /* ---------- location: country first (default United States), then a region and postal code that fit the country ---------- */
  var COUNTRY_CODES = ('US CA GB AU NZ IE IN MX DE FR IT ES NL BE CH AT SE NO DK FI PT PL CZ GR HU RO IL AE SA QA KW TR EG ZA NG KE MA ' +
    'JP KR CN HK TW SG MY TH VN PH ID PK BD LK BR AR CL CO PE EC UY VE CR PA DO PR JM TT GT HN SV NI BO PY CU BS BB ' +
    'IS LU MT CY EE LV LT SK SI HR RS BA ME MK AL BG UA MD BY GE AM AZ KZ UZ JO LB OM BH IQ IR AF NP MM KH LA MN ' +
    'GH CI SN CM ET TZ UG RW ZM ZW BW NA MU MG TN DZ LY SD FJ PG WS TO').split(' ');
  var LOC = {
    US: { region: 'State', postal: 'ZIP code', eg: '85001', pat: /^\d{5}(-\d{4})?$/ },
    CA: { region: 'Province or territory', postal: 'Postal code', eg: 'M5V 2T6', pat: /^[A-Z]\d[A-Z] ?\d[A-Z]\d$/i,
          list: ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'] },
    GB: { region: 'County', postal: 'Postcode', eg: 'SW1A 1AA', pat: /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i },
    IE: { region: 'County', postal: 'Eircode', eg: 'D02 X285', pat: /^[A-Z\d]{3} ?[A-Z\d]{4}$/i },
    AU: { region: 'State or territory', postal: 'Postcode', eg: '2000', pat: /^\d{4}$/, list: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'] },
    NZ: { region: 'Region', postal: 'Postcode', eg: '1010', pat: /^\d{4}$/ },
    IN: { region: 'State', postal: 'PIN code', eg: '110001', pat: /^\d{6}$/ },
    MX: { region: 'State', postal: 'Postal code', eg: '06000', pat: /^\d{5}$/ },
    DE: { region: 'State', postal: 'Postal code', eg: '10115', pat: /^\d{5}$/ },
    FR: { region: 'Region', postal: 'Postal code', eg: '75001', pat: /^\d{5}$/ },
    IT: { region: 'Province', postal: 'CAP', eg: '00118', pat: /^\d{5}$/ },
    ES: { region: 'Province', postal: 'Postal code', eg: '28001', pat: /^\d{5}$/ },
    NL: { region: 'Province', postal: 'Postcode', eg: '1011 AB', pat: /^\d{4} ?[A-Z]{2}$/i },
    BR: { region: 'State', postal: 'CEP', eg: '01310-100', pat: /^\d{5}-?\d{3}$/ },
    JP: { region: 'Prefecture', postal: 'Postal code', eg: '100-0001', pat: /^\d{3}-?\d{4}$/ },
    PH: { region: 'Province', postal: 'ZIP code', eg: '1000', pat: /^\d{4}$/ },
    PR: { region: 'Municipality', postal: 'ZIP code', eg: '00901', pat: /^\d{5}(-\d{4})?$/ },
    AE: { region: 'Emirate', postal: '' }, HK: { region: 'District', postal: '' }, SG: { region: '', postal: 'Postal code', eg: '018956', pat: /^\d{6}$/ },
    QA: { region: 'Municipality', postal: '' }
  };
  var LOC_DEFAULT = { region: 'State, province or region', postal: 'Postal code', eg: '' };
  var countryNames = (function () {
    var dn = null;
    try { dn = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) { dn = null; }
    var out = {};
    COUNTRY_CODES.forEach(function (c) { var n = ''; try { n = dn ? dn.of(c) : ''; } catch (e) { n = ''; } out[c] = n && n !== c ? n : c; });
    out.US = 'United States';
    return out;
  })();
  function locOf(c) { return LOC[c] || LOC_DEFAULT; }
  function fillCountries() {
    var sel = field('mk-p-country');
    if (!sel || sel.getAttribute('data-filled')) return;
    var rest = COUNTRY_CODES.filter(function (c) { return c !== 'US'; }).sort(function (a, b) { return countryNames[a].localeCompare(countryNames[b]); });
    sel.innerHTML = '<option value="US">United States</option><option disabled>----------</option>' +
      rest.map(function (c) { return '<option value="' + c + '">' + esc(countryNames[c]) + '</option>'; }).join('');
    sel.setAttribute('data-filled', '1');
  }
  function drawLocation() {
    var sel = field('mk-p-country'); if (!sel) return;
    var c = sel.value || 'US', cfg = locOf(c), isUS = c === 'US';
    var us = root.querySelector('[data-mk-region-us]'), other = root.querySelector('[data-mk-region-other]');
    if (us) us.hidden = !isUS;
    if (other) other.hidden = isUS || !cfg.region;
    var rl = root.querySelector('[data-mk-region-label]'); if (rl) rl.textContent = cfg.region || '';
    var dl = root.querySelector('[data-mk-region-list]');
    if (dl) dl.innerHTML = (cfg.list || []).map(function (x) { return '<option value="' + x + '">'; }).join('');
    var pw = root.querySelector('[data-mk-postal-wrap]'), pl = root.querySelector('[data-mk-postal-label]'), pi = field('mk-p-postal');
    if (pw) pw.hidden = !cfg.postal;
    if (pl) pl.textContent = cfg.postal || 'Postal code';
    if (pi) { pi.placeholder = cfg.eg || ''; pi.inputMode = cfg.pat && /^\^\\d/.test(String(cfg.pat.source)) ? 'numeric' : 'text'; }
    checkPostal();
  }
  function checkPostal() {
    var pi = field('mk-p-postal'), w = root.querySelector('[data-mk-postal-warn]'), sel = field('mk-p-country');
    if (!pi || !w || !sel) return true;
    var cfg = locOf(sel.value || 'US'), val = pi.value.trim();
    var bad = !!(val && cfg.pat && !cfg.pat.test(val));
    w.hidden = !bad;
    w.textContent = bad ? 'Check the format' + (cfg.eg ? ', for example ' + cfg.eg : '') + '. You can still save.' : '';
    return !bad;
  }
  var EQUIP = ['Stand mixer', 'Hand mixer', 'Food processor', 'Kitchen scale', 'Instant-read thermometer', 'Ice cream maker',
               'Kitchen torch', 'Bread machine', 'Dutch oven', 'Air fryer', 'Piping set', 'Espresso machine'];
  var GOALS = ['Bake bread', 'Master pastry', 'Decorate cakes', 'Bake with kids', 'Lighter baking', 'Holiday and gift baking',
               'Sell my bakes', 'Cafe drinks at home'];
  var FORMATS = ['Video lessons', 'Step-by-step photos', 'Printable recipes', 'Podcasts', 'Quick tips'];
  var GOAL_WORD = { 'Bake bread': 'bread', 'Master pastry': 'pastry', 'Decorate cakes': 'cake', 'Bake with kids': 'cookies',
                    'Lighter baking': 'yogurt', 'Holiday and gift baking': 'gift', 'Sell my bakes': 'bars', 'Cafe drinks at home': 'latte' };
  /* US Census regions, matching the events calendar's "region" field */
  var REGION = {};
  [['Northeast', 'CT ME MA NH RI VT NJ NY PA'], ['Midwest', 'IL IN MI OH WI IA KS MN MO NE ND SD'],
   ['South', 'DE DC FL GA MD NC SC VA WV AL KY MS TN AR LA OK TX'], ['West', 'AZ CO ID MT NV NM UT WY AK CA HI OR WA']]
    .forEach(function (r) { r[1].split(' ').forEach(function (st) { REGION[st] = r[0]; }); });
  /* Same lists as the sync service (apps_script/my_kitchen_v4_profile.gs) */
  var CATEGORIES = ['Baking Fundamentals', 'Cakes & Cupcakes', 'Cookies & Bars', 'Pastries & Croissants', 'Pies & Tarts',
                    'Doughnuts & Sweet Doughs', 'Bread & Enriched Dough', 'Custards & Cr\u00e8me Br\u00fbl\u00e9e', 'Chocolate & Confections',
                    'Ice Cream & Frozen Desserts', 'Frostings, Fillings & Icings', 'Coffee, Tea & Barista Skills', 'Drinks', 'Other'];
  var INTERESTS = CATEGORIES.filter(function (c) { return c !== 'Other'; });
  var FLAVORS = ['Brown butter', 'Maple', 'Pecan', 'Chocolate', 'Citrus', 'Berry', 'Chai spice', 'Caramel', 'Coffee',
                 'Pistachio', 'Coconut', 'Pumpkin spice', 'Floral', 'Honey'];
  var LOVES = ['Pies', 'Bread', 'Cookies', 'Cakes', 'Cheesecakes', 'Ice cream', 'Doughnuts', 'Pastry', 'Custards',
               'Candy', 'Cafe drinks', 'Tea'];
  var DIETS = ['Gluten-free', 'Dairy-free', 'Vegan', 'Egg-free', 'Nut-free'];
  var SHOW_KEYS = ['about', 'top5', 'style', 'badges', 'bakes', 'social', 'city'];
  var COLORS = { gold: ['#c9962e', '#2f2118'], oak: ['#5c4033', '#fffdf9'], sage: ['#dfe7d6', '#2f2118'],
                 blush: ['#f3e1d6', '#2f2118'], sky: ['#dde6ee', '#2f2118'], cream: ['#f7f1e8', '#2f2118'] };
  var ICONS = {
    whisk: '<path d="M12 13v8M12 13c-4 0-6-5-6-8a6 6 0 0 1 12 0c0 3-2 8-6 8z"/><path d="M12 3v10M9 4c0 4 1 7 3 9M15 4c0 4-1 7-3 9"/>',
    pin: '<rect x="6" y="9" width="12" height="6" rx="3"/><path d="M2 12h4M18 12h4"/>',
    cake: '<path d="M5 12h14l-2 8H7z"/><path d="M6 12a6 4 0 0 1 12 0"/><path d="M12 5v3"/>',
    flower: '<circle cx="12" cy="12" r="2.5"/><path d="M12 9.5c0-3 1-5 0-6.5-1 1.5 0 3.5 0 6.5zM14.5 12c3 0 5 1 6.5 0-1.5-1-3.5 0-6.5 0zM12 14.5c0 3-1 5 0 6.5 1-1.5 0-3.5 0-6.5zM9.5 12c-3 0-5-1-6.5 0 1.5 1 3.5 0 6.5 0z"/>',
    cup: '<path d="M5 9h11v6a5 5 0 0 1-5 5h-1a5 5 0 0 1-5-5z"/><path d="M16 11h2a2 2 0 0 1 0 4h-2"/><path d="M9 3c-1 1.5 1 2.5 0 4M12 3c-1 1.5 1 2.5 0 4"/>',
    bread: '<path d="M5 11a7 4 0 0 1 14 0v8H5z"/><path d="M9 9l-1 3M13 8.5l-1 3"/>',
    pie: '<path d="M3 13h18l-2 6H5z"/><path d="M3 13c2-5 16-5 18 0"/><path d="M8 11l2-2M12 10l2-2"/>',
    cookie: '<circle cx="12" cy="12" r="8"/><circle cx="9" cy="10" r="1"/><circle cx="14" cy="9" r="1"/><circle cx="13" cy="14" r="1"/><circle cx="9" cy="15" r="1"/>'
  };
  var SOCIAL = { instagram: ['IG', 'Instagram', 'https://www.instagram.com/'], tiktok: ['TT', 'TikTok', 'https://www.tiktok.com/@'],
                 pinterest: ['P', 'Pinterest', 'https://www.pinterest.com/'], youtube: ['YT', 'YouTube', 'https://www.youtube.com/@'],
                 website: ['www', 'Website', ''] };
  var SEARCH_WORD = { 'Baking Fundamentals': 'vanilla cake', 'Cakes & Cupcakes': 'cake', 'Cookies & Bars': 'cookies', 'Pastries & Croissants': 'pastry',
                      'Pies & Tarts': 'pie', 'Doughnuts & Sweet Doughs': 'doughnuts', 'Bread & Enriched Dough': 'bread',
                      'Custards & Cr\u00e8me Br\u00fbl\u00e9e': 'custard', 'Chocolate & Confections': 'chocolate', 'Ice Cream & Frozen Desserts': 'ice cream',
                      'Frostings, Fillings & Icings': 'frosting', 'Coffee, Tea & Barista Skills': 'latte', 'Drinks': 'latte' };
  var LOVE_WORD = { Pies: 'pie', Bread: 'bread', Cookies: 'cookies', Cakes: 'cake', Cheesecakes: 'cheesecake', 'Ice cream': 'ice cream',
                    Doughnuts: 'doughnuts', Pastry: 'pastry', Custards: 'custard', Candy: 'caramel', 'Cafe drinks': 'latte', Tea: 'tea latte' };
  var DRINK_RX = /\b(latte|smoothie|milkshake|shake|malt|frapp|cocoa|hot chocolate|coffee|espresso|tea|chai|matcha|lemonade|soda|cocktail|mocktail|creamer|syrup|cold brew|float)\b/i;
  var HEART = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';

  /* ---------- v3 (Oct 2026): the recipe search index (read-only key from the section settings) gives the picks, the
     facts on recipe cards (category, flavor, time, how a drink is served) and the Bakes / Drinks split ---------- */
  var TS = { host: root.getAttribute('data-ts-host') || '', key: root.getAttribute('data-ts-key') || '', coll: root.getAttribute('data-ts-collection') || 'recipes' };
  var tsCache = {};
  function tsFetch(path, body) {
    if (!TS.host || !TS.key || !window.fetch) return Promise.resolve(null);
    var key = path + (body ? JSON.stringify(body) : '');
    if (tsCache[key]) return tsCache[key];
    tsCache[key] = fetch('https://' + TS.host + path, body
      ? { method: 'POST', headers: { 'X-TYPESENSE-API-KEY': TS.key, 'Content-Type': 'application/json' }, body: JSON.stringify(body) }
      : { headers: { 'X-TYPESENSE-API-KEY': TS.key } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return tsCache[key];
  }
  function tsSearch(params) {
    var q = new URLSearchParams(Object.assign({ q: '*', query_by: 'title' }, params));
    return tsFetch('/collections/' + encodeURIComponent(TS.coll) + '/documents/search?' + q.toString());
  }
  var FACT_FIELDS = 'id,browse,dish,flavor,kind,active_minutes,tags,image_url,url,title';
  var facts = {}, factsJobs = {};                   // article id -> { browse, dish, flavor, kind, min, serve }; id -> its lookup
  function serveOf(tags) {
    var t = (tags || []).join('|').toLowerCase();
    if (/blended|frapp|milkshake|smoothie/.test(t)) return 'Blended';
    if (/hot drink|hot chocolate|steamer|hot tea/.test(t)) return 'Hot';
    if (/iced|cold brew|cold coffee|refresher|lemonade/.test(t)) return 'Iced';
    if (/frozen/.test(t)) return 'Frozen';
    return '';
  }
  function minutesText(m) { m = Number(m) || 0; return m ? (m >= 60 ? Math.floor(m / 60) + ' hr' + (m % 60 ? ' ' + (m % 60) + ' min' : '') : m + ' min') : ''; }
  function factOf(d) {
    return { browse: d.browse || '', dish: d.dish || '', flavor: d.flavor && d.flavor !== 'Classic' ? d.flavor : '', kind: d.kind || '',
             min: Number(d.active_minutes) || 0, serve: d.kind === 'Drinks' ? serveOf(d.tags) : '', i: d.image_url || '', u: d.url || '', n: d.title || '' };
  }
  function loadFacts(ids) {   // resolves once every id's facts are known (shared lookups, so two callers never race)
    ids = ids.map(String).filter(function (id, i, a) { return /^\d+$/.test(id) && a.indexOf(id) === i; });
    var fresh = ids.filter(function (id) { return !factsJobs[id]; });
    for (var i = 0; i < fresh.length; i += 60) {
      (function (chunk) {
        var job = tsSearch({ filter_by: 'id:=[' + chunk.join(',') + ']', per_page: 60, include_fields: FACT_FIELDS }).then(function (res) {
          ((res && res.hits) || []).forEach(function (h) { facts[String(h.document.id)] = factOf(h.document); });
          chunk.forEach(function (id) { if (!facts[id]) facts[id] = null; });
          paintFacts();
        });
        chunk.forEach(function (id) { factsJobs[id] = job; });
      })(fresh.slice(i, i + 60));
    }
    return Promise.all(ids.map(function (id) { return factsJobs[id]; })).then(function () { return facts; });
  }
  function factLine(id) {
    var f = facts[String(id)];
    if (!f) return '';
    return [f.dish || f.browse, f.flavor, f.serve, f.min ? minutesText(f.min) + ' hands-on' : ''].filter(Boolean).join(' \u00b7 ');
  }
  function paintFacts() {
    root.querySelectorAll('[data-mk-facts]').forEach(function (el) { var t = factLine(el.getAttribute('data-mk-facts')); if (t) el.textContent = t; });
    root.querySelectorAll('[data-mk-seg]').forEach(function (el) { el.hidden = !segNeeded(el.getAttribute('data-mk-seg')); });
  }
  function isDrink(id, item) {
    item = item || {};
    var f = facts[String(id)];
    if (f && f.kind) return f.kind === 'Drinks';
    if (item.k) return item.k === 'drink';
    return DRINK_RX.test(item.n || '');
  }
  var seg = { recipes: 'all', bakes: 'all' }, segCounts = { recipes: [0, 0], bakes: [0, 0] };   // the All / Bakes / Drinks switch
  function segNeeded(name) { var c = segCounts[name] || [0, 0]; return c[0] > 0 && c[1] > 0; }
  function segHtml(name) {
    return '<div class="mk-seg" role="group" aria-label="Show" data-mk-seg="' + name + '"' + (segNeeded(name) ? '' : ' hidden') + '>' +
      [['all', 'All'], ['bake', 'Bakes'], ['drink', 'Drinks']].map(function (o) {
        return '<button type="button" data-mk-seg-pick="' + o[0] + '" aria-pressed="' + (seg[name] === o[0]) + '">' + o[1] + '</button>';
      }).join('') + '</div>';
  }
  function segKeep(name, id, item) { return seg[name] === 'all' || (seg[name] === 'drink') === isDrink(id, item); }
  function segCount(name, id, item) { segCounts[name][isDrink(id, item) ? 1 : 0] += 1; }
  var BADGE_NAMES = { 'first-bake': 'First bake', 'five-bakes': 'Five bakes', explorer: 'Recipe explorer', 'twenty-bakes': 'Twenty bakes',
                      notes: 'Notes keeper', 'first-lesson': 'First lesson', course: 'Course complete', 'three-courses': 'Three courses',
                      steady: 'Steady baker', 'first-photo': 'First bake photo', barista: 'Barista' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2); }
  function json(sel) { var el = root.querySelector(sel) || document.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* no analytics */ } }
  function sized(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function thumb(cls, label, img) {
    return '<span class="mk-thumb mk-t-' + cls + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : label) + '</span>';
  }
  function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(String(iso).length === 10 ? iso + 'T12:00:00' : iso);
    return isNaN(d) ? '' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function shortDay(d) { var dt = new Date(d + 'T12:00:00'); return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function dayTile(d) { var dt = new Date(d + 'T12:00:00'); return dt.toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + '<br>' + dt.getDate(); }
  function weekday(d) { return new Date(d + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'long' }); }

  var NOW = new Date(), today = ymd(NOW);
  var monday = new Date(NOW); monday.setDate(NOW.getDate() - ((NOW.getDay() + 6) % 7)); monday.setHours(12, 0, 0, 0);
  var weekStart = ymd(monday), weekNo = Math.floor((monday - new Date(monday.getFullYear(), 0, 1)) / 604800000);
  function seeded(seed) { var x = seed % 2147483647; if (x <= 0) x += 2147483646; return function () { x = x * 16807 % 2147483647; return (x - 1) / 2147483646; }; }

  var toastEl;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'mk-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    toastEl.classList.add('on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('on'); }, 4200);
  }

  /* ---------- sections ---------- */
  var ALIAS = { overview: ['week'], recipes: ['saved', 'recipes'], journal: ['saved', 'journal'], books: ['saved', 'books'],
                products: ['saved', 'products'], tools: ['saved', 'tools'], desserts: ['saved', 'desserts'], pets: ['saved', 'pets'], markets: ['out'], events: ['out'], submissions: ['shared'], reviews: ['shared'] };
  var sheet = root.querySelector('[data-mk-sheet-panel]'), sheetNav = root.querySelector('[data-mk-sheetnav]');
  var sideNav = root.querySelector('[data-mk-navlist]');
  if (sheetNav && sideNav) sheetNav.innerHTML = sideNav.innerHTML;
  function go(id, push) {
    var tab = null;
    if (ALIAS[id]) { tab = ALIAS[id][1] || null; id = ALIAS[id][0]; }
    var panel = root.querySelector('[data-mk-panel="' + id + '"]');
    if (!panel) return;
    root.querySelectorAll('[data-mk-panel]').forEach(function (p) { p.classList.toggle('is-on', p === panel); });
    var label = '';
    root.querySelectorAll('.mk-nav [data-mk-go], .mk-ptabs [data-mk-go]').forEach(function (b) {
      if (b.getAttribute('data-mk-go') === id) { b.setAttribute('aria-current', 'page'); if (!label) label = (b.querySelector('span') || b).textContent; }
      else b.removeAttribute('aria-current');
    });
    var pt = root.querySelector('[data-mk-ptitle]');
    if (pt && label) pt.textContent = label;
    if (tab) showTab(tab);
    closeSheet();
    if (push && history.replaceState) history.replaceState(null, '', id === 'week' ? location.pathname + location.search : '#' + id);
    if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start' });
    if (id === 'public') drawPublic();
  }
  window.vgMkGo = function (id) { go(id, true); };
  function openSheet() { if (!sheet) return; sheet.hidden = false; document.documentElement.classList.add('mk-sheet-open'); var f = sheet.querySelector('button'); if (f) f.focus(); }
  function closeSheet() { if (!sheet || sheet.hidden) return; sheet.hidden = true; document.documentElement.classList.remove('mk-sheet-open'); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  function showTab(name) {
    root.querySelectorAll('[data-mk-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-mk-tab') === name ? 'true' : 'false'); });
    root.querySelectorAll('[data-mk-tabpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-mk-tabpanel') !== name; });
  }

  /* ---------- data ---------- */
  var academy = json('[data-mk-academy]') || [];
  var season = json('[data-mk-season]');
  var eventsData = json('script[data-vge-data]');
  var eventsById = {};
  if (eventsData && eventsData.items) eventsData.items.forEach(function (it) { eventsById[it.id] = it; });

  function list(k) { return me.read(k) || (k === K.recipes || k === K.events ? [] : {}); }
  function setCount(name, n) { root.querySelectorAll('[data-mk-count="' + name + '"]').forEach(function (el) { el.textContent = n ? n : ''; }); }
  function emptyMsg(text, href, label) { return '<p class="mk-empty">' + esc(text) + (href ? ' <a href="' + esc(href) + '">' + esc(label) + '</a>.' : '') + '</p>'; }
  function removeLink(kind, key) { return '<button type="button" class="mk-link" data-mk-remove="' + kind + '" data-key="' + esc(key) + '">Remove</button>'; }
  function tile(attrs, pic, body, actions, side) {
    return '<div class="mk-tile"' + (attrs || '') + '><div class="mk-tile-top">' + pic + '<span class="mk-grow">' + body + '</span>' + (side || '') + '</div>' +
      (actions ? '<div class="mk-tile-acts">' + actions + '</div>' : '') + '</div>';
  }
  function planBtn(id, n, u, i) {
    var on = !!list(K.plan)[id];
    return '<button type="button" class="mk-btn mk-btn--sm' + (on ? ' is-on' : '') + '" data-mk-plan-add="' + esc(id) + '" data-n="' + esc(n) + '" data-u="' + esc(u) + '" data-i="' + esc(i || '') + '"' +
      (on ? ' aria-pressed="true">On my week' : ' aria-pressed="false">Add to my week') + '</button>';
  }

  /* ---------- saved products (prices from Shopify's product feed) ---------- */
  var productCache = {};
  function productKind(h) {
    if (/coffee|espresso|roast|blend/.test(h)) return ['coffee', 'Coffee'];
    if (/tea|chai|matcha/.test(h)) return ['tea', 'Tea'];
    if (/extract|paste|powder|sugar/.test(h)) return ['extract', 'Extract'];
    return ['bean', 'Vanilla'];
  }
  function drawProducts() {
    var box = root.querySelector('[data-mk-list="saved"]'), all = root.querySelector('[data-mk-all-to-cart]');
    var saved = list(K.products), handles = Object.keys(saved).sort(function (a, b) { return (saved[b].t || 0) - (saved[a].t || 0); });
    setCount('saved', handles.length);
    if (all) all.hidden = handles.length < 2;
    if (!box) return handles.length;
    if (!handles.length) { box.innerHTML = emptyMsg('Tap "Save for later" on any product and it will wait for you here.', '/collections/all', 'Browse products'); return 0; }
    box.innerHTML = handles.map(function (h) {
      var kind = productKind(h);
      return tile(' data-mk-product="' + esc(h) + '"', thumb(kind[0], kind[1]),
        '<strong><a href="' + esc(saved[h].u || '/products/' + h) + '">' + esc(saved[h].n || h) + '</a></strong><span data-price>Checking today\'s price</span>',
        '<button type="button" class="mk-btn mk-btn--solid mk-btn--sm" data-mk-add="' + esc(h) + '" disabled>Add to cart</button>' + removeLink('products', h));
    }).join('');
    handles.forEach(function (h) {
      (productCache[h] ? Promise.resolve(productCache[h]) : fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }))
        .then(function (p) {
          var t = box.querySelector('[data-mk-product="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
          if (!t) return;
          if (!p) { t.querySelector('[data-price]').textContent = 'No longer available'; return; }
          productCache[h] = p;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (p.featured_image) t.querySelector('.mk-thumb').innerHTML = '<img src="' + esc(sized(p.featured_image, 160)) + '" alt="" loading="lazy">';
          t.querySelector('[data-price]').textContent = v ? money(v.price) + ' \u00b7 In stock' : 'Sold out';
          var btn = t.querySelector('[data-mk-add]');
          if (v) { btn.disabled = false; btn.setAttribute('data-variant', v.id); } else { btn.textContent = 'Sold out'; }
        }).catch(function () { /* offline */ });
    });
    return handles.length;
  }

  /* ---------- recipes and journal articles (both saved with the heart, split by blog) ---------- */
  function articles() {
    var ids = list(K.recipes).map(String), meta = (me.meta() || {}).recipes || {};
    var out = { recipes: [], journal: [] };
    ids.slice().reverse().forEach(function (id) {
      var m = meta[id];
      (m && m.u && m.u.indexOf('/blogs/recipes/') !== 0 ? out.journal : out.recipes).push({ id: id, m: m });
    });
    return out;
  }
  function articleTile(a, journal) {
    var m = a.m;
    var title = m ? '<a href="' + esc(m.u) + '">' + esc(m.n) + '</a>' : (journal ? 'Saved article' : 'Saved recipe');
    var sub = m ? (journal ? (m.b || 'Journal') : (factLine(a.id) || 'Saved recipe')) : 'Details appear once your saves sync';
    return tile('', thumb(journal ? 'journal' : 'recipe', journal ? 'Article' : 'Recipe', m && m.i ? sized(m.i, 160) : ''),
      '<strong>' + title + '</strong><span>' + (journal || !m ? esc(sub) : '<span class="mk-facts" data-mk-facts="' + esc(a.id) + '">' + esc(sub) + '</span>') + '</span>',
      (m ? (journal ? '<a class="mk-btn mk-btn--sm" href="' + esc(m.u) + '">Read article</a>' : planBtn(a.id, m.n, m.u, m.i)) : '') + removeLink('recipes', a.id),
      '<button type="button" class="mk-heart" aria-pressed="true" data-mk-remove="recipes" data-key="' + esc(a.id) + '" aria-label="Remove from saved">' + HEART + '</button>');
  }
  function drawArticles() {
    var a = articles();
    setCount('recipes', a.recipes.length);
    setCount('journal', a.journal.length);
    var rb = root.querySelector('[data-mk-list="recipes"]'), jb = root.querySelector('[data-mk-list="journal"]');
    if (rb) {
      segCounts.recipes = [0, 0];
      a.recipes.forEach(function (x) { segCount('recipes', x.id, x.m || {}); });
      var shown = a.recipes.filter(function (x) { return segKeep('recipes', x.id, x.m || {}); });
      rb.innerHTML = a.recipes.length ? segHtml('recipes') + (shown.length ? shown.map(function (x) { return articleTile(x, false); }).join('') : '<p class="mk-empty">Nothing in this group yet.</p>')
        : emptyMsg('Tap the heart on any recipe to save it here.', '/pages/recipes', 'Find recipes');
      loadFacts(a.recipes.map(function (x) { return x.id; }));
    }
    if (jb) jb.innerHTML = a.journal.length ? a.journal.map(function (x) { return articleTile(x, true); }).join('')
      : emptyMsg('Tap the heart on any journal article (vanilla origins, extract craft, coffee and tea guides) to keep it here.', '/pages/blog-search-page', 'Read the journal');
    return a;
  }

  /* ---------- books ---------- */
  function drawBooks() {
    var box = root.querySelector('[data-mk-list="books"]'), books = list(K.books);
    var ids = Object.keys(books).sort(function (a, b) { return (books[b].t || 0) - (books[a].t || 0); });
    setCount('books', ids.length);
    if (!box) return ids.length;
    if (!ids.length) { box.innerHTML = emptyMsg('Tap "Save to My Kitchen" on any book in the Bookshelf or the Cookbook Guide.', '/pages/bookshelf', 'Open the Bookshelf'); return 0; }
    box.innerHTML = ids.map(function (id) {
      var b = books[id];
      var from = b.from && b.from.indexOf('cookbook') > -1 ? 'Cookbook Guide' : 'Bookshelf';
      return tile('', '<span class="mk-thumb mk-t-book mk-thumb--book">' + (b.c ? '<img src="' + esc(b.c) + '" alt="" loading="lazy">' : 'Book') + '</span>',
        '<strong>' + esc(b.n || 'Saved book') + '</strong><span>' + esc((b.by ? b.by + ' \u00b7 ' : '') + 'From the ' + from) + '</span>',
        (b.u ? '<a class="mk-btn mk-btn--sm" href="' + esc(b.u) + '" target="_blank" rel="sponsored nofollow noopener">View on Amazon</a>' : '') + removeLink('books', id));
    }).join('');
    return ids.length;
  }

  /* ---------- tools (saved on Baking Tools calculator pages) ---------- */
  function drawTools() {
    var tools = list(K.tools), keys = Object.keys(tools).sort(function (a, b) { return (tools[b].t || 0) - (tools[a].t || 0); });
    setCount('tools', keys.length);
    var hub = '/pages/baking-tools';
    var box = root.querySelector('[data-mk-list="tools"]'), quick = root.querySelector('[data-mk-list="tools-quick"]');
    if (box) box.innerHTML = keys.length ? keys.map(function (k) {
      var t = tools[k];
      return tile('', '<span class="mk-thumb mk-t-tool">' + esc((t.n || 'Tool').charAt(0)) + '</span>',
        '<strong><a href="' + esc(t.u || '/pages/' + k) + '">' + esc(t.n || 'Baking tool') + '</a></strong><span>' + esc(t.c || 'Baking Tools') + '</span>',
        '<a class="mk-btn mk-btn--sm mk-btn--solid" href="' + esc(t.u || '/pages/' + k) + '">Open tool</a>' + removeLink('tools', k));
    }).join('') : emptyMsg('Tap "Save to My Kitchen" on any calculator in Baking Tools and it will wait for you here.', hub, 'Browse 51 baking tools');
    if (quick) quick.innerHTML = keys.length ? keys.slice(0, 8).map(function (k) {
      var t = tools[k];
      return '<a class="mk-toolchip" href="' + esc(t.u || '/pages/' + k) + '"><span>' + esc(t.n || 'Baking tool') + '</span><small>' + esc(t.c || '') + '</small></a>';
    }).join('') + (keys.length > 8 ? '<button type="button" class="mk-link" data-mk-go="tools">All ' + keys.length + ' saved tools</button>' : '')
      : [['Recipe scaling', '/pages/recipe-scaling-calculator', 'Double or halve any recipe'], ['Cups to grams', '/pages/cups-to-grams-converter', '100+ ingredients'],
         ['Pan sizes', '/pages/baking-pan-size-converter', 'Swap cake pans'], ['Simple syrup', '/pages/sugar-syrup-calculator', 'For drinks and desserts']].map(function (t) {
          return '<a class="mk-toolchip" href="' + t[1] + '"><span>' + t[0] + '</span><small>' + t[2] + '</small></a>';
        }).join('') + '<p class="mk-sub mk-toolnote">Popular with members. Save your own from any calculator in <a href="' + hub + '">Baking Tools</a> and they\'ll sit here.</p>';
    return keys.length;
  }

  /* ---------- desserts (built in the Dessert Builder) ---------- */
  function drawDesserts() {
    var ds = list(K.desserts), keys = Object.keys(ds).sort(function (a, b) { return (ds[b].c || 0) - (ds[a].c || 0); });
    setCount('desserts', keys.length);
    var hub = '/pages/dessert-builder';
    var box = root.querySelector('[data-mk-list="desserts"]');
    var kind = { cake: 'Layer cake', cupcake: 'Cupcakes', pie: 'Pie', cheesecake: 'Cheesecake', doughnut: 'Doughnuts' };
    if (box) box.innerHTML = keys.length ? keys.map(function (k) {
      var d = ds[k];
      return tile('', '<span class="mk-thumb mk-t-tool">' + esc((d.n || 'D').charAt(0)) + '</span>',
        '<strong><a href="' + esc(d.u || hub) + '">' + esc(d.n || 'Your dessert') + '</a></strong><span>' + esc((kind[d.t] || 'Dessert') + ' · ' + ((d.p || '').split(',').filter(Boolean).length || 1) + ' parts · Dessert Builder') + '</span>',
        '<a class="mk-btn mk-btn--sm mk-btn--solid" href="' + esc(d.u || hub) + '">Open recipe</a>' + removeLink('desserts', k));
    }).join('') : emptyMsg('Build a cake, cupcakes, a pie, a cheesecake or doughnuts from our recipes and tap "Save to My Kitchen"; it will wait for you here.', hub, 'Open the Dessert Builder');
    return keys.length;
  }

  /* ---------- Farmers Basket: saved baskets (vg_baskets_v1, written by assets/vg-farmers-basket.js) ---------- */
  var FB_URL = '/pages/farmers-basket';
  function basketKeys() { var bs = list(K.baskets); return Object.keys(bs).sort(function (a, b) { return (bs[b].t || 0) - (bs[a].t || 0); }); }
  function basketUrl(b) { var st = ''; for (var i = 0; i < 9; i++) st += b['s' + i] || ''; return FB_URL + (st ? '#' + st : ''); }
  function basketSub(b) {
    var c = Number(b.c) || 0;
    return c + ' food' + (c === 1 ? '' : 's') + (b.t ? ' \u00b7 saved ' + new Date(b.t).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '');
  }
  /* Food photos for the basket previews come from the Farmers Basket page's own data block (#vg-fb-data), fetched once. */
  var fbPics = null, fbPicsLoading = false, basketRenaming = null;
  function basketSlugs(b) {
    var st = ''; for (var i = 0; i < 9; i++) st += b['s' + i] || '';
    var m = /(?:^|&)b=([^&]*)/.exec(st);
    return m ? m[1].split(',').map(function (x) { return x.split(':')[0]; }).filter(Boolean) : [];
  }
  function loadBasketPics() {
    if (fbPics || fbPicsLoading) return;
    try { fbPics = JSON.parse(sessionStorage.getItem('vg_fb_pics') || 'null'); } catch (e) { fbPics = null; }
    if (fbPics) return;
    fbPicsLoading = true;
    fetch(FB_URL).then(function (r) { return r.text(); }).then(function (html) {
      var m = /<script[^>]*id="vg-fb-data"[^>]*>([\s\S]*?)<\/script>/.exec(html), map = {};
      (m ? JSON.parse(m[1]) : []).forEach(function (it) { if (it.slug && it.img) map[it.slug] = [it.img, it.name || '']; });
      fbPics = map;
      try { sessionStorage.setItem('vg_fb_pics', JSON.stringify(map)); } catch (e) { /* full */ }
      drawBaskets();
    })['catch'](function () { fbPics = {}; }).then(function () { fbPicsLoading = false; });
  }
  function basketPics(b) {
    if (!fbPics) return '';
    var slugs = basketSlugs(b), shown = slugs.filter(function (s) { return fbPics[s]; }).slice(0, 6);
    return '<span class="mk-bpics">' + shown.map(function (s) {
      return '<img src="' + esc(fbPics[s][0] + (fbPics[s][0].indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="' + esc(fbPics[s][1]) + '" width="44" height="44" loading="lazy">';
    }).join('') + (slugs.length > shown.length ? '<span class="mk-bmore">+' + (slugs.length - shown.length) + '</span>' : '') + '</span>';
  }
  function drawBaskets(msg) {
    var bs = list(K.baskets), keys = basketKeys();
    setCount('baskets', keys.length);
    var note = root.querySelector('[data-mk-basket-msg]');
    if (note && msg != null) note.textContent = msg;
    var box = root.querySelector('[data-mk-list="baskets"]');
    if (keys.length) loadBasketPics();
    if (box) box.innerHTML = keys.length ? keys.map(function (k) {
      var b = bs[k], u = basketUrl(b);
      var name = basketRenaming === k
        ? '<form class="mk-colform mk-brename" data-mk-basket-rename="' + esc(k) + '" novalidate><label>Basket name<input maxlength="60" value="' + esc(b.n || '') + '" autocomplete="off"></label>' +
          '<button type="submit" class="mk-btn mk-btn--sm mk-btn--solid">Save</button><button type="button" class="mk-link" data-mk-basket-act="cancel" data-key="' + esc(k) + '">Cancel</button></form>'
        : '<strong><a href="' + esc(u) + '">' + esc(b.n || 'My basket') + '</a></strong>';
      return tile(' data-mk-basket="' + esc(k) + '"', '<span class="mk-thumb mk-t-tool">' + esc((b.n || 'B').charAt(0)) + '</span>',
        name + '<span>' + esc(basketSub(b)) + '</span>' + basketPics(b),
        '<a class="mk-btn mk-btn--sm mk-btn--solid" href="' + esc(u) + '">Open</a>' +
        '<button type="button" class="mk-link" data-mk-basket-act="rename" data-key="' + esc(k) + '">Rename</button>' +
        '<button type="button" class="mk-link" data-mk-basket-act="delete" data-key="' + esc(k) + '">Delete</button>');
    }).join('') + '<p class="mk-note">' + keys.length + ' of 10 baskets saved.' + (keys.length >= 10 ? ' Delete one to save another.' : '') + '</p>'
      : '<p class="mk-empty">Fill a basket with fresh fruit, vegetables, nuts, dairy and eggs, see its nutrition for the day or week, and save up to 10 here. <a href="' + FB_URL + '">Build your first basket</a>.</p>';
    var inp = basketRenaming && box && box.querySelector('[data-mk-basket-rename] input');
    if (inp) { inp.focus(); inp.select(); }
    return keys.length;
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mk-basket-act]'); if (!a) return;
    var k = a.getAttribute('data-key'), act = a.getAttribute('data-mk-basket-act'), bs = list(K.baskets), b = bs[k];
    if (act === 'cancel') { basketRenaming = null; drawBaskets(''); return; }
    if (!b) return;
    if (act === 'rename') { basketRenaming = k; drawBaskets(''); return; }
    if (act === 'delete' && window.confirm('Delete "' + (b.n || 'this basket') + '"?')) {
      delete bs[k]; if (basketRenaming === k) basketRenaming = null;
      me.set(K.baskets, bs); drawBaskets('Deleted "' + (b.n || 'Basket') + '".'); drawBasketsCard();
    }
  });
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-mk-basket-rename]'); if (!f) return;
    e.preventDefault();
    var k = f.getAttribute('data-mk-basket-rename'), bs = list(K.baskets), name = f.querySelector('input').value.replace(/\s+/g, ' ').trim().slice(0, 60);
    basketRenaming = null;
    if (bs[k] && name) { bs[k].n = name; me.set(K.baskets, bs); drawBaskets('Renamed to "' + name + '".'); drawBasketsCard(); }
    else drawBaskets('');
  });
  function drawBasketsCard() {
    var box = root.querySelector('[data-mk-baskets-card]'); if (!box) return;
    var bs = list(K.baskets), all = basketKeys(), keys = all.slice(0, 3);
    box.innerHTML = '<div class="mk-cardhead"><h2>Farmers Basket</h2>' + (all.length ? '<button type="button" class="mk-link" data-mk-go="baskets">' + (all.length > 3 ? 'All ' + all.length + ' baskets' : 'My baskets') + '</button>' : '<span class="mk-sub">Fresh food nutrition</span>') + '</div>' +
      (keys.length ? keys.map(function (k) {
        var b = bs[k];
        return '<div class="mk-row"><span class="mk-thumb mk-t-tool">' + esc((b.n || 'B').charAt(0)) + '</span><span class="mk-grow"><strong><a href="' + esc(basketUrl(b)) + '">' + esc(b.n || 'My basket') + '</a></strong><span>' + esc(basketSub(b)) + '</span></span></div>';
      }).join('') : '<p class="mk-sub">Fill a basket with fresh food for the week and see its food groups and nutrients. Save up to 10 baskets and open them on any device.</p>') +
      '<div class="mk-actions"><a class="mk-btn mk-btn--sm' + (keys.length ? '' : ' mk-btn--solid') + '" href="' + FB_URL + '">' + (keys.length ? 'Build a new basket' : 'Build your first basket') + '</a></div>';
  }

  /* ---------- BakeBudget (vg_bakebudget_v1, written by assets/vg-bakebudget.js) ----------
     {cfg:{b: budget, p: 'w'|'m', z}, plan:{s0..s10: "handle*batches~..."}, log:{s0..: "YYYYMMDD|amount|i/k/s|note~..."}} */
  var BB_URL = '/pages/bakebudget', BB_CAT = { i: 'Ingredients', k: 'Bakery purchases', s: 'Supplies' };
  function bbStr(e) { var s = ''; if (e) for (var i = 0; i < 11; i++) s += e['s' + i] || ''; return s; }
  function bbState() {
    var raw = list(K.bakebudget), cfg = raw.cfg || {}, plan = [], log = [];
    bbStr(raw.plan).split('~').forEach(function (x) { var m = /^([a-z0-9-]+)\*([\d.]+)$/.exec(x); if (m) plan.push({ h: m[1], m: +m[2] }); });
    bbStr(raw.log).split('~').forEach(function (x) {
      var m = /^(\d{4})(\d{2})(\d{2})\|([\d.]+)\|([iks])\|(.*)$/.exec(x); if (m) log.push({ d: m[1] + '-' + m[2] + '-' + m[3], a: +m[4], c: m[5], n: m[6] });
    });
    var pan = bbStr(raw.pan).split(',').filter(Boolean).length;
    return { amt: +cfg.b || 0, per: cfg.p === 'm' ? 'm' : 'w', plan: plan, log: log, pantry: pan, any: !!(cfg.b || plan.length || log.length || pan) };
  }
  function bbRange(per) {
    var d = new Date(); d.setHours(12, 0, 0, 0);
    if (per === 'm') return [new Date(d.getFullYear(), d.getMonth(), 1, 12), new Date(d.getFullYear(), d.getMonth() + 1, 0, 12)];
    var s = new Date(d.getTime() - ((d.getDay() + 6) % 7) * 864e5); return [s, new Date(s.getTime() + 6 * 864e5)];
  }
  function bbYmd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function bbMoney(v) { return '$' + (Math.round(v * 100) / 100).toFixed(2); }
  function bbNames() { try { return JSON.parse(localStorage.getItem('vg_bakebudget_names') || '{}') || {}; } catch (e) { return {}; } }
  function bbTitle(h, names) { if (names && names[h]) return names[h]; var t = h.replace(/-/g, ' '); return t.charAt(0).toUpperCase() + t.slice(1); }
  function bbSpent(b) { var r = bbRange(b.per), a = bbYmd(r[0]), z = bbYmd(r[1]), t = 0; b.log.forEach(function (x) { if (x.d >= a && x.d <= z) t += x.a; }); return t; }
  function drawBakeBudget() {
    var b = bbState(), box = root.querySelector('[data-mk-list="bakebudget"]'), names = bbNames();
    setCount('bakebudget', b.plan.length);
    if (!box) return;
    if (!b.any) { box.innerHTML = '<p class="mk-empty">Set a weekly or monthly baking budget, pick recipes, and see what they cost to bake and to shop at store prices updated every day. <a href="' + BB_URL + '">Start your BakeBudget</a>.</p>'; return; }
    var per = b.per === 'm' ? 'this month' : 'this week', spent = bbSpent(b);
    box.innerHTML = '<div class="mk-tile" style="grid-column:1/-1"><div class="mk-tile-top"><span class="mk-thumb mk-t-tool">$</span><span class="mk-grow"><strong>' +
      (b.amt ? bbMoney(spent) + ' spent of ' + bbMoney(b.amt) + ' ' + per : bbMoney(spent) + ' spent ' + per) + '</strong><span>' +
      (b.amt ? (b.amt - spent >= 0 ? bbMoney(b.amt - spent) + ' still free' : bbMoney(spent - b.amt) + ' over budget') : 'No budget set yet') +
      (b.pantry ? ' · ' + b.pantry + ' item' + (b.pantry === 1 ? '' : 's') + ' in your pantry' : '') + '</span></span></div></div>' +
      (b.plan.length ? '<h3 class="mk-shop-h" style="grid-column:1/-1">Planned bakes</h3>' + b.plan.map(function (p) {
        return tile('', '<span class="mk-thumb mk-t-tool">' + esc(bbTitle(p.h, names).charAt(0)) + '</span>', '<strong><a href="/blogs/recipes/' + esc(p.h) + '">' + esc(bbTitle(p.h, names)) + '</a></strong><span>' + (p.m === 1 ? '1 batch' : p.m + ' batches') + '</span>', '');
      }).join('') : '<p class="mk-sub">No recipes planned. <a href="' + BB_URL + '">Pick some on BakeBudget</a>.</p>') +
      (b.log.length ? '<h3 class="mk-shop-h" style="grid-column:1/-1">Latest spending</h3>' + b.log.slice(0, 5).map(function (x) {
        return '<div class="mk-row" style="grid-column:1/-1"><span class="mk-grow"><strong>' + bbMoney(x.a) + '</strong> ' + esc(BB_CAT[x.c] || '') + (x.n ? ' · ' + esc(x.n) : '') + '<span>' + esc(new Date(x.d + 'T12:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' })) + '</span></span></div>';
      }).join('') : '') +
      '<div class="mk-actions" style="grid-column:1/-1"><a class="mk-btn mk-btn--sm mk-btn--solid" href="' + BB_URL + '">Open BakeBudget</a></div>';
  }
  function drawBakeBudgetCard() {
    var box = root.querySelector('[data-mk-bb-card]'); if (!box) return;
    var b = bbState(), spent = bbSpent(b), per = b.per === 'm' ? 'this month' : 'this week';
    box.innerHTML = '<div class="mk-cardhead"><h2>BakeBudget</h2>' + (b.any ? '<button type="button" class="mk-link" data-mk-go="bakebudget">My budget</button>' : '<span class="mk-sub">Baking on a budget</span>') + '</div>' +
      (b.any ? '<p class="mk-sub"><strong>' + bbMoney(spent) + '</strong> spent ' + per + (b.amt ? ' of ' + bbMoney(b.amt) : '') + ' · ' + b.plan.length + ' bake' + (b.plan.length === 1 ? '' : 's') + ' planned</p>'
        : '<p class="mk-sub">See what any recipe costs to bake, per serving and to shop, at store prices updated every day. Set a budget and track what you spend.</p>') +
      '<div class="mk-actions"><a class="mk-btn mk-btn--sm' + (b.any ? '' : ' mk-btn--solid') + '" href="' + BB_URL + '">' + (b.any ? 'Open BakeBudget' : 'Plan a baking budget') + '</a></div>';
  }

  /* ---------- bakes (bake log from recipe pages) ---------- */
  function bakeTotal() { return madeTotal('all'); }
  function madeTotal(kind) {   // 'all' | 'bake' | 'drink'
    var b = list(K.bakes);
    return Object.keys(b).reduce(function (n, k) { return n + ((kind === 'all' || (kind === 'drink') === isDrink(k, b[k])) ? (Number(b[k].c) || 0) : 0); }, 0);
  }
  function starText(r) { return r ? new Array(Number(r) + 1).join('\u2605') + new Array(6 - Number(r)).join('\u2606') : ''; }
  function drawBakes() {
    var box = root.querySelector('[data-mk-list="bakes"]'), bakes = list(K.bakes);
    var ids = Object.keys(bakes).sort(function (a, b) { return String(bakes[b].d || '').localeCompare(String(bakes[a].d || '')); });
    setCount('bakes', ids.length);
    if (!box) return;
    if (!ids.length) { box.innerHTML = emptyMsg('Nothing logged yet. Tap "I made this" under the steps of any recipe you bake, or tick one off your bake list.', '/pages/recipes', 'Find a recipe'); return; }
    segCounts.bakes = [0, 0];
    ids.forEach(function (id) { segCount('bakes', id, bakes[id]); });
    var shownIds = ids.filter(function (id) { return segKeep('bakes', id, bakes[id]); });
    box.innerHTML = segHtml('bakes') + (shownIds.length ? shownIds.map(function (id) {
      var b = bakes[id], stars = starText(b.r);
      var made = b.c ? 'Made ' + (Number(b.c) === 1 ? 'once' : b.c + ' times') + (b.d ? ', last on ' + shortDay(b.d) : '') : 'Note only';
      return tile('', thumb('recipe', 'Recipe', b.i),
        '<strong>' + (b.u ? '<a href="' + esc(b.u) + '">' + esc(b.n || 'Recipe') + '</a>' : esc(b.n || 'Recipe')) + '</strong>' +
        '<span>' + esc(made) + (stars ? ' \u00b7 <span aria-label="' + b.r + ' of 5 stars">' + stars + '</span>' : '') + '</span>' +
        '<span class="mk-facts" data-mk-facts="' + esc(id) + '">' + esc(factLine(id)) + '</span>' +
        (b.t ? '<span class="mk-sub">' + esc(b.t) + '</span>' : ''),
        (b.u ? '<a class="mk-btn mk-btn--sm" href="' + esc(b.u) + '#VgBake">Open recipe</a>' : '') + (b.u ? planBtn(id, b.n, b.u, b.i) : '') + removeLink('bakes', id));
    }).join('') : '<p class="mk-empty">Nothing in this group yet.</p>');
    loadFacts(ids);
  }

  /* ---------- the week: bake list (vg_plan_v1), week strip, bake-along ---------- */
  function planEntries() {
    var plan = list(K.plan), changed = false;
    Object.keys(plan).forEach(function (id) {             // last week's ticked recipes leave the list on Monday
      if (plan[id] && plan[id].x && plan[id].x < weekStart) { delete plan[id]; changed = true; }
    });
    if (changed) me.set(K.plan, plan);
    return Object.keys(plan).map(function (id) { return { id: id, p: plan[id] }; })
      .sort(function (a, b) { return (a.p.x ? 1 : 0) - (b.p.x ? 1 : 0) || String(a.p.a || '').localeCompare(String(b.p.a || '')); });
  }
  function planRow(x) {
    var p = x.p, done = !!p.x, verb = isDrink(x.id, p) ? 'Made' : 'Baked';
    var sub = done ? verb + ' ' + weekday(p.x) : (p.a ? 'Added ' + shortDay(p.a) : 'On your list');
    return '<div class="mk-prow' + (done ? ' is-done' : '') + '">' +
      '<button type="button" class="mk-tick' + (done ? ' is-done' : '') + '" data-mk-tick="' + esc(x.id) + '" aria-pressed="' + done + '" aria-label="' + (done ? 'Undo: not made yet' : 'Mark ' + esc(p.n) + ' as ' + verb.toLowerCase()) + '"></button>' +
      thumb('recipe', '', p.i) +
      '<span class="mk-grow"><strong>' + (p.u ? '<a href="' + esc(p.u) + '">' + esc(p.n || 'Recipe') + '</a>' : esc(p.n || 'Recipe')) + '</strong><span>' + esc(sub) + '</span></span>' +
      (done ? '<span class="mk-pill mk-pill--ok">' + verb + '</span>' : '<button type="button" class="mk-link" data-mk-plan-remove="' + esc(x.id) + '">Remove</button>') + '</div>';
  }
  function drawPlan() {
    var rows = planEntries(), todo = rows.filter(function (x) { return !x.p.x; }).length;
    var html = rows.length ? rows.map(planRow).join('') : '';
    var wk = root.querySelector('[data-mk-list="plan-week"]'), full = root.querySelector('[data-mk-list="plan"]');
    if (wk) wk.innerHTML = html || '<p class="mk-empty">Nothing planned yet. Tap <strong>Add to my week</strong> on any recipe, or <button type="button" class="mk-link" data-mk-go="bakes">search for one here</button>.</p>' + planStarters();
    if (full) full.innerHTML = html || '<p class="mk-empty">Your bake list is empty. Search below, or tap Add to my week on a recipe page.</p>' + planStarters();
    root.querySelectorAll('[data-mk-shop-open]').forEach(function (b) { b.hidden = !todo; });
    var shopCard = root.querySelector('[data-mk-shop]');
    if (shopCard && !shopCard.hidden && !shopCard.getAttribute('data-busy')) { shopCard.setAttribute('data-busy', '1'); setTimeout(function () { shopCard.removeAttribute('data-busy'); drawShop(); }, 0); }
    // week strip: a dot on each day you baked
    var strip = root.querySelector('[data-mk-weekstrip]');
    if (strip) {
      var bakedDays = {};
      var bakes = list(K.bakes);
      Object.keys(bakes).forEach(function (k) { if (bakes[k].d >= weekStart) bakedDays[bakes[k].d] = true; });
      rows.forEach(function (x) { if (x.p.x) bakedDays[x.p.x] = true; });
      var cells = [];
      for (var i = 0; i < 7; i++) {
        var d = new Date(monday); d.setDate(monday.getDate() + i);
        var key = ymd(d);
        cells.push('<span class="mk-day' + (bakedDays[key] ? ' is-baked' : '') + (key === today ? ' is-today' : '') + '"><small>' +
          d.toLocaleDateString('en-US', { weekday: 'short' }) + '</small><b>' + d.getDate() + '</b><i aria-hidden="true"></i>' +
          (bakedDays[key] ? '<span class="mk-visually-hidden">baked</span>' : '') + '</span>');
      }
      strip.innerHTML = cells.join('');
    }
    return { rows: rows, todo: todo };
  }
  function planStarters() {
    var opts = alongPicks().map(function (r) { return { u: r.u, n: r.t, i: r.img, along: true }; });
    articles().recipes.slice(0, 3).forEach(function (x) { if (x.m) opts.push({ id: x.id, u: x.m.u, n: x.m.n, i: x.m.i }); });
    if (!opts.length) return '';
    return '<div class="mk-starters"><span class="mk-sub">Start with:</span>' + opts.slice(0, 5).map(function (o) {
      return o.along ? '<button type="button" class="mk-chip" data-mk-along-add="' + esc(o.u) + '" data-n="' + esc(o.n) + '" data-i="' + esc(o.i || '') + '">+ ' + esc(o.n) + '</button>'
        : '<button type="button" class="mk-chip" data-mk-plan-add="' + esc(o.id) + '" data-n="' + esc(o.n) + '" data-u="' + esc(o.u) + '" data-i="' + esc(o.i || '') + '">+ ' + esc(o.n) + '</button>';
    }).join('') + '</div>';
  }
  function tick(id) {
    var plan = list(K.plan), p = plan[id];
    if (!p) return;
    var bakes = list(K.bakes), b = bakes[id] || { c: 0, r: 0, t: '' };
    if (p.x) {                                           // undo
      if (p.x === today && b.c) {
        b.c = b.c - 1;
        if (b.h) { var hh = String(b.h).split(','), at = hh.lastIndexOf(today); if (at > -1) hh.splice(at, 1); b.h = hh.join(','); }
        if (!b.c && !b.r && !b.t) delete bakes[id]; else bakes[id] = b;
      }
      delete p.x;
      plan[id] = p;
      me.set(K.plan, plan); me.set(K.bakes, bakes);
      drawAll();
      return;
    }
    b.c = (Number(b.c) || 0) + 1; b.f = b.f || today; b.d = today;
    b.h = ((b.h ? String(b.h) + ',' : '') + today).split(',').slice(-26).join(',');
    b.n = p.n; b.u = p.u; b.i = p.i; b.k = isDrink(id, p) ? 'drink' : 'bake';
    bakes[id] = b;
    p.x = today; plan[id] = p;
    me.set(K.bakes, bakes); me.set(K.plan, plan);
    track('plan_baked', { article_id: id });
    drawAll();
    toast('Logged in My bakes. <a href="' + esc((p.u || '') + '#VgBake') + '">Rate it or add a note</a>');
  }
  function planToggle(id, n, u, i) {
    var plan = list(K.plan);
    if (plan[id]) delete plan[id];
    else {
      if (Object.keys(plan).length >= 12) { toast('Your week already has 12 recipes. Tick some off first.'); return false; }
      plan[id] = { n: String(n || '').slice(0, 200), u: String(u || '').slice(0, 290), i: String(i || '').slice(0, 290), a: today };
    }
    me.set(K.plan, plan);
    track(plan[id] ? 'plan_add' : 'plan_remove', { article_id: id, from: 'my_kitchen' });
    return !!plan[id];
  }

  function alongPicks() {
    if (!season || !season.recipes || !season.recipes.length) return [];
    var r = season.recipes, w = Math.floor((NOW.getDate() - 1) / 7), out = [];
    for (var i = 0; i < Math.min(3, r.length); i++) out.push(r[(w * 3 + i) % r.length]);
    return out;
  }
  function urlKey(u) { return String(u || '').split('?')[0].split('#')[0].replace(/\/$/, ''); }
  function bakedSince(urls, since) {
    var bakes = list(K.bakes), hit = {};
    Object.keys(bakes).forEach(function (k) {
      var b = bakes[k];
      if (b.d >= since && urls.indexOf(urlKey(b.u)) > -1) hit[urlKey(b.u)] = true;
    });
    return hit;
  }
  function drawAlong() {
    var box = root.querySelector('[data-mk-along-list]');
    if (!box) return;
    var picks = alongPicks(), urls = picks.map(function (r) { return urlKey(r.u); }), hit = bakedSince(urls, weekStart);
    var plan = list(K.plan), planUrls = Object.keys(plan).map(function (k) { return urlKey(plan[k].u); });
    box.innerHTML = picks.map(function (r) {
      var k = urlKey(r.u), baked = hit[k], planned = planUrls.indexOf(k) > -1;
      return '<div class="mk-along-item">' + thumb('recipe', '', r.img) + '<span class="mk-grow"><strong><a href="' + esc(r.u) + '">' + esc(r.t) + '</a></strong>' +
        '<span>' + (r.min ? esc(r.min >= 60 ? Math.floor(r.min / 60) + ' hr' + (r.min % 60 ? ' ' + (r.min % 60) + ' min' : '') : r.min + ' min') : '') + '</span></span>' +
        (baked ? '<span class="mk-pill mk-pill--ok">Baked</span>' : planned ? '<span class="mk-pill">On my week</span>'
          : '<button type="button" class="mk-btn mk-btn--sm" data-mk-along-add="' + esc(r.u) + '" data-n="' + esc(r.t) + '" data-i="' + esc(r.img) + '">Add to my week</button>') + '</div>';
    }).join('');
    var n = Object.keys(hit).length, bar = root.querySelector('[data-mk-along-bar]'), st = root.querySelector('[data-mk-along-status]');
    if (bar) { bar.querySelector('i').style.width = Math.min(100, Math.round(100 * n / Math.max(1, picks.length))) + '%'; bar.setAttribute('aria-label', n + ' of ' + picks.length + ' baked this week'); }
    if (st) st.textContent = n ? 'You baked ' + n + ' of this week\'s ' + picks.length + '. Nice work.' : 'New picks every Monday. Bake one to join in.';
  }
  /* Recipe pages give us article ids; season recipes only have links, so look the id up once when adding one. */
  function addByUrl(u, n, i) {
    var handle = urlKey(u).split('/').pop();
    return suggest(n || handle.replace(/-/g, ' '), 'article')
      .then(function (res) {
        var hit = (res || []).filter(function (a) { return urlKey(a.url) === urlKey(u); })[0];
        var id = hit ? String(hit.id) : 'u:' + handle;
        planToggle(id, n || (hit && hit.title), urlKey(u), i || (hit && hit.image) || '');
        drawAll();
        toast('Added to your week.');
      });
  }

  /* ---------- milestones: bakes and lessons only, never purchases; nothing resets ---------- */
  function milestones(st) {
    var bakes = list(K.bakes), ids = Object.keys(bakes);
    var total = madeTotal('bake'), notes = ids.filter(function (k) { return bakes[k].t; }).length;
    var lessons = Object.keys(st.prog).filter(function (k) { return k !== '__last'; }).length;
    var done = academy.filter(function (c) { return c.l.length && c.l.every(function (l) { return st.prog[l.h]; }); });
    var m = [
      ['first-bake', 'First bake', 'Log your first bake', total, 1],
      ['five-bakes', 'Five bakes', 'Log 5 bakes', total, 5],
      ['explorer', 'Recipe explorer', 'Bake 10 different recipes', ids.filter(function (k) { return bakes[k].c && !isDrink(k, bakes[k]); }).length, 10],
      ['twenty-bakes', 'Twenty bakes', 'Log 20 bakes', total, 20],
      ['barista', 'Barista', 'Make 10 drinks', madeTotal('drink'), 10],
      ['notes', 'Notes keeper', 'Keep notes on 5 recipes', notes, 5],
      ['first-lesson', 'First lesson', 'Finish an Academy lesson', lessons, 1],
      ['course', 'Course complete', 'Finish every lesson in a course', done.length, 1],
      ['three-courses', 'Three courses', 'Finish 3 Academy courses', done.length, 3],
      ['steady', 'Steady baker', 'Bake in 4 different weeks', bakeWeeks().length, 4],
      ['first-photo', 'First bake photo', 'Share a photo of something you baked', Object.keys(list(K.bakes)).filter(function (k) { return list(K.bakes)[k].p; }).length, 1]
    ];
    var goal = Number((me.profile() || {}).goal) || 0;
    if (goal) m.push(['goal-' + NOW.getFullYear(), NOW.getFullYear() + ' goal', 'Reach your goal of ' + goal + ' bakes this year', yearBakes(), goal]);
    if (season && season.recipes && season.month) {
      var monthStart = ymd(new Date(NOW.getFullYear(), NOW.getMonth(), 1));
      var hit = bakedSince(season.recipes.map(function (r) { return urlKey(r.u); }), monthStart);
      var key = 'season-' + NOW.getFullYear() + '-' + ('0' + (NOW.getMonth() + 1)).slice(-2);
      BADGE_NAMES[key] = season.month + ' bake-along';
      m.push([key, season.month + ' bake-along', 'Bake one of ' + season.month + '\'s bake-along recipes', Object.keys(hit).length, 1]);
    }
    m = m.map(function (x) { return { k: x[0], n: x[1], d: x[2], have: Math.min(x[3], x[4]), need: x[4], got: x[3] >= x[4] }; });
    return { list: m, done: done, lessons: lessons };
  }
  function drawMilestones(st) {
    var ms = milestones(st);
    root.querySelectorAll('[data-mk-milestones]').forEach(function (box) { drawMilestoneBox(box, ms, box.hasAttribute('data-mk-compact')); });
  }
  function drawMilestoneBox(box, ms, compact) {
    var got = ms.list.filter(function (x) { return x.got; });
    var open = ms.list.filter(function (x) { return !x.got; }).sort(function (a, b) { return (b.have / b.need) - (a.have / a.need); });
    var next = open[0];
    var shown = compact ? got.slice(-2).concat(open).slice(0, 4) : ms.list;
    box.hidden = false;
    box.innerHTML = '<div class="mk-cardhead"><h2>Milestones</h2><span class="mk-sub">' + got.length + ' of ' + ms.list.length + ' earned</span></div>' +
      '<ul class="mk-badges">' + shown.map(function (x) {
        return '<li class="mk-badge' + (x.got ? ' is-got' : '') + '" title="' + esc(x.d) + '"><strong>' + esc(x.n) + '</strong><span>' +
          (x.got ? 'Earned' : x.have + ' of ' + x.need) + '</span></li>';
      }).join('') + '</ul>' +
      (next ? '<p class="mk-sub">Next up: ' + esc(next.d.charAt(0).toLowerCase() + next.d.slice(1)) + ' (' + next.have + ' of ' + next.need + ').' +
        (compact ? ' <button type="button" class="mk-link" data-mk-go="bakes">See all</button>' : '') + '</p>' : '<p class="mk-sub">Every milestone earned. Lovely baking.</p>') +
      (!compact && ms.done.length ? '<div class="mk-actions">' + ms.done.map(function (c) {
        return '<button type="button" class="mk-btn mk-btn--sm" data-mk-cert="' + esc(c.h) + '">Certificate: ' + esc(c.n) + '</button>';
      }).join('') + '</div>' : '');
  }
  function printCertificate(handle) {
    var c = academy.filter(function (x) { return x.h === handle; })[0];
    if (!c) return;
    var box = root.querySelector('[data-mk-milestones]'), name = (me.profile() || {}).name || (box && box.getAttribute('data-mk-name')) || 'A VanillaGoods baker';
    var day = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    var w = window.open('', '_blank');
    if (!w) { toast('Allow pop-ups for this site to open your certificate.'); return; }
    w.document.write('<!doctype html><html><head><meta charset="utf-8"><title>Certificate: ' + esc(c.n) + '</title><style>' +
      'body{margin:0;font-family:Georgia,serif;color:#2f2118;background:#fff}' +
      '.c{margin:40px auto;max-width:760px;border:6px double #c9962e;padding:56px 48px;text-align:center}' +
      'small{letter-spacing:.2em;text-transform:uppercase;color:#a07a2c}h1{font-size:40px;margin:14px 0 6px}' +
      'h2{font-size:30px;margin:22px 0 4px;font-style:italic}p{font-size:17px;line-height:1.5;margin:8px 0}' +
      '.f{margin-top:36px;font-size:14px;color:#6b5444}@media print{.c{margin:0 auto}button{display:none}}' +
      'button{margin:0 auto 30px;display:block;padding:10px 22px;border-radius:999px;border:0;background:#2f2118;color:#fff;font:16px Georgia,serif;cursor:pointer}' +
      '</style></head><body><div class="c"><small>VanillaGoods Baking Academy</small><h1>Certificate of completion</h1>' +
      '<p>This certifies that</p><h2>' + esc(name) + '</h2><p>completed every lesson in</p><h2>' + esc(c.n) + '</h2>' +
      '<p class="f">' + esc(day) + ' \u00b7 vanillagoods.com/pages/baking-academy</p></div>' +
      '<button onclick="window.print()">Print or save as PDF</button></body></html>');
    w.document.close();
    track('certificate_open', { course: handle });
  }

  /* ---------- markets ---------- */
  function favMarkets() {
    var favs = list(K.markets);
    return Object.keys(favs).sort(function (a, b) { return String(favs[b].saved || '').localeCompare(String(favs[a].saved || '')); })
      .map(function (id) { var m = favs[id]; return { id: id, m: m, where: [m.city, m.state].filter(Boolean).join(', ') }; });
  }
  function drawMarkets() {
    var box = root.querySelector('[data-mk-list="markets"]'), all = favMarkets();
    setCount('markets', all.length);
    if (!box) return all.length;
    if (!all.length) { box.innerHTML = emptyMsg('Tap the heart on a farmers market to keep it here.', '/pages/farmers-market-finder', 'Find markets'); return 0; }
    box.innerHTML = all.map(function (x) {
      var m = x.m;
      var dir = m.lat != null && m.lng != null ? 'https://www.google.com/maps/dir/?api=1&destination=' + m.lat + ',' + m.lng
                                               : 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent((m.name || '') + ' ' + x.where);
      return tile('', thumb('market', 'Market'),
        '<strong><a href="' + esc(m.url || '/pages/farmers-market-finder') + '">' + esc(m.name || 'Farmers market') + '</a></strong><span>' + esc(x.where) + '</span>',
        '<a class="mk-btn mk-btn--sm" href="' + esc(dir) + '" target="_blank" rel="noopener">Directions</a>' + removeLink('markets', x.id));
    }).join('');
    return all.length;
  }

  /* ---------- events ---------- */
  function gcal(it) {
    var end = new Date(it.e + 'T12:00:00'); end.setDate(end.getDate() + 1);
    var dates = it.s.replace(/-/g, '') + '/' + end.toISOString().slice(0, 10).replace(/-/g, '');
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(it.name) + '&dates=' + dates +
      (it.loc ? '&location=' + encodeURIComponent(it.loc) : '');
  }
  function upcomingEvents() {
    return list(K.events).map(function (id) { return eventsById[id]; }).filter(Boolean)
      .filter(function (it) { return !it.e || it.e >= today; })
      .sort(function (a, b) { return String(a.s || '9').localeCompare(String(b.s || '9')); });
  }
  /* Events in the member's state first, then the rest of their region, over the next 60 days (from their profile state) */
  function nearbyEvents() {
    var st = (me.profile() || {}).state || '';
    if (!st || !eventsData || !eventsData.items) return [];
    var until = ymd(new Date(NOW.getTime() + 60 * 86400000)), region = REGION[st];
    return eventsData.items.filter(function (it) { return it.kind !== 'holiday' && it.s && (it.e || it.s) >= today && it.s <= until && (it.st === st || (region && it.region === region)); })
      .map(function (it) { return { it: it, same: it.st === st }; })
      .sort(function (a, b) { return (b.same - a.same) || String(a.it.s).localeCompare(String(b.it.s)); }).slice(0, 6);
  }
  function eventWhere(it) { return it.loc || (it.city ? it.city + (it.state ? ', ' + it.state : '') : (it.kind === 'holiday' ? 'Food holiday' : '')); }
  function drawEvents() {
    var box = root.querySelector('[data-mk-list="events"]'), up = root.querySelector('[data-mk-list="upcoming"]');
    var saved = list(K.events).filter(function (id) { return eventsById[id]; }), next = upcomingEvents(), past = saved.length - next.length;
    setCount('events', next.length);
    if (box) {
      box.innerHTML = next.length ? next.map(function (it) {
        var when = it.s ? shortDay(it.s) + (it.e && it.e !== it.s ? ' to ' + shortDay(it.e) : '') : 'Date to be announced';
        var where = eventWhere(it);
        return tile('', thumb('event', it.s ? dayTile(it.s) : 'TBA'),
          '<strong><a href="' + esc(EVENTS_URL + '#vge-' + it.id) + '">' + esc(it.name) + '</a></strong><span>' + esc(when + (where ? ' \u00b7 ' + where : '')) + '</span>',
          (it.s ? '<a class="mk-btn mk-btn--sm" href="' + esc(gcal(it)) + '" target="_blank" rel="noopener">Add to calendar</a>' : '') + removeLink('events', it.id));
      }).join('') + (past ? '<p class="mk-note">' + past + ' past event' + (past === 1 ? '' : 's') + ' hidden.</p>' : '')
        : emptyMsg('Save festivals and food holidays from the Events calendar to see them here.', EVENTS_URL, 'Open the calendar');
    }
    var near = nearbyEvents(), st = (me.profile() || {}).state || '';
    var nb = root.querySelector('[data-mk-list="nearby"]'), nh = root.querySelector('[data-mk-nearby-h]');
    if (nh) nh.textContent = st ? 'Coming up near you (' + st + ' and the ' + (REGION[st] || 'region') + ')' : 'Coming up near you';
    var ctry = (me.profile() || {}).country || 'US';
    if (nb && ctry !== 'US') { nb.innerHTML = '<p class="mk-empty">Our festival and food-event listings cover the United States for now. <a href="' + esc(EVENTS_URL) + '">Browse the events calendar</a>.</p>'; }
    else if (nb) nb.innerHTML = !st ? '<p class="mk-empty">Add your state in <button type="button" class="mk-link" data-mk-go="profile">My profile</button> to see festivals and food events near you.</p>'
      : near.length ? near.map(function (x) {
        var it = x.it, when = it.s ? shortDay(it.s) + (it.e && it.e !== it.s ? ' to ' + shortDay(it.e) : '') : '';
        return tile('', thumb('event', it.s ? dayTile(it.s) : 'TBA'),
          '<strong><a href="' + esc(EVENTS_URL + '#vge-' + it.id) + '">' + esc(it.name) + '</a></strong><span>' + esc(when + ' \u00b7 ' + [it.city, it.st].filter(Boolean).join(', ')) + '</span>' +
          '<span class="mk-pill' + (x.same ? ' mk-pill--ok' : '') + '">' + (x.same ? 'In ' + esc(it.st) : esc(it.region || 'Nearby')) + '</span>',
          '<a class="mk-btn mk-btn--sm" href="' + esc(EVENTS_URL + '#vge-' + it.id) + '">Details</a>');
      }).join('') : emptyMsg('No festivals near ' + st + ' on the calendar right now. New ones are added every month.', EVENTS_URL, 'See every event');
    var upH = root.querySelector('[data-mk-upcoming-h]');
    if (upH) upH.textContent = st && near.length ? 'Coming up and near you' : 'Coming up';
    if (up) {
      var rows = next.slice(0, 3).map(function (it) {
        return '<div class="mk-row">' + thumb('event', it.s ? dayTile(it.s) : 'TBA') + '<span class="mk-grow"><strong><a href="' + esc(EVENTS_URL + '#vge-' + it.id) + '">' + esc(it.name) + '</a></strong><span>' + esc(eventWhere(it) || 'Saved event') + '</span></span></div>';
      });
      var savedIds = next.map(function (it) { return it.id; });
      near.filter(function (x) { return savedIds.indexOf(x.it.id) === -1; }).slice(0, Math.max(0, 3 - rows.length)).forEach(function (x) {
        rows.push('<div class="mk-row">' + thumb('event', dayTile(x.it.s)) + '<span class="mk-grow"><strong><a href="' + esc(EVENTS_URL + '#vge-' + x.it.id) + '">' + esc(x.it.name) + '</a></strong><span>' + esc((x.same ? 'Near you' : 'In the ' + (x.it.region || 'region')) + ' \u00b7 ' + (x.it.city || '')) + '</span></span></div>');
      });
      favMarkets().slice(0, Math.max(0, 3 - rows.length)).forEach(function (x) {
        rows.push('<div class="mk-row">' + thumb('market', 'Market') + '<span class="mk-grow"><strong><a href="' + esc(x.m.url || '/pages/farmers-market-finder') + '">' + esc(x.m.name || 'Farmers market') + '</a></strong><span>' + esc('Your favorite' + (x.where ? ' \u00b7 ' + x.where : '')) + '</span></span></div>');
      });
      up.innerHTML = rows.length ? rows.join('') : (!st ? '<p class="mk-empty">Add your state in <button type="button" class="mk-link" data-mk-go="profile" data-mk-focus="mk-p-state">My profile</button> and festivals and food events near you show up here.</p>'
        : '<p class="mk-empty">Nothing near ' + esc(st) + ' on the calendar right now. Save festivals from the <a href="' + esc(EVENTS_URL) + '">events calendar</a>, or favorite a <a href="/pages/farmers-market-finder">farmers market</a>.</p>');
    }
    return next;
  }

  /* ---------- Academy ---------- */
  function academyState() {
    var prog = list(K.progress), saved = list(K.saved), started = [];
    academy.forEach(function (c) {
      var done = c.l.filter(function (l) { return prog[l.h]; }).length;
      var next = c.l.filter(function (l) { return !prog[l.h]; })[0];
      if (done || saved['course:' + c.h]) started.push({ c: c, done: done, next: next, n: c.l.length });
    });
    started.sort(function (a, b) { return (b.done > 0 && b.done < b.n) - (a.done > 0 && a.done < a.n) || b.done - a.done; });
    var cur = started.filter(function (s) { return s.done > 0 && s.next; })[0] || null;
    return { prog: prog, saved: saved, started: started, cur: cur };
  }
  function drawAcademy(st) {
    var box = root.querySelector('[data-mk-list="courses"]'), savedBox = root.querySelector('[data-mk-list="academy-saved"]');
    var savedKeys = Object.keys(st.saved).filter(function (k) { return k.indexOf('lesson:') === 0 || k.indexOf('course:') === 0; });
    setCount('academy', st.started.length);
    if (box) {
      box.innerHTML = st.started.length ? st.started.map(function (s) {
        var pct = s.n ? Math.round(100 * s.done / s.n) : 0, complete = s.n && s.done >= s.n;
        var act = complete ? '<span class="mk-pill mk-pill--ok">Completed</span>'
          : '<a class="mk-btn ' + (s.done ? 'mk-btn--solid ' : '') + 'mk-btn--sm" href="' + esc((s.next || s.c).u) + '">' + (s.done ? 'Continue' : 'Start') + '</a>';
        return tile('', thumb('lesson', 'Course', s.c.l[0] && s.c.l[0].th),
          '<strong><a href="' + esc(s.c.u) + '">' + esc(s.c.n) + '</a></strong><span>' + esc((s.c.lv || 'Beginner') + ' \u00b7 ' + s.done + ' of ' + s.n + ' lessons') + '</span>' +
          '<span class="mk-bar" role="img" aria-label="' + s.done + ' of ' + s.n + ' lessons done"><i style="width:' + pct + '%"></i></span>',
          act + (st.saved['course:' + s.c.h] ? removeLink('saved', 'course:' + s.c.h) : ''));
      }).join('') : emptyMsg('Start a free course and your progress will show here.', ACADEMY_URL, 'Browse the Baking Academy');
    }
    // starter boxes (example courses and podcast topics) until anything is started or saved
    var starter = root.querySelector('[data-mk-academy-starter]');
    if (starter) {
      var anySaved = Object.keys(st.saved).some(function (k) { return /^(lesson|course|podcast|show|episode):/.test(k); });
      var fresh = !st.started.length && !anySaved;
      starter.hidden = !fresh;
      if (fresh && box) box.innerHTML = '<p class="mk-empty">Pick a free course or a podcast topic below. Your progress, saved lessons and certificates will show here.</p>';
    }
    var lessons = savedKeys.filter(function (k) { return k.indexOf('lesson:') === 0; });
    var card = root.querySelector('[data-mk-saved-lessons-card]');
    if (card) card.hidden = !lessons.length;
    if (savedBox) {
      savedBox.innerHTML = lessons.sort(function (a, b) { return (st.saved[b].t || 0) - (st.saved[a].t || 0); }).map(function (k) {
        var it = st.saved[k];
        return '<div class="mk-row">' + thumb('lesson', 'Lesson') + '<span class="mk-grow"><strong><a href="' + esc(it.url) + '">' + esc(it.title) + '</a></strong><span>' + esc(it.sub || '') + '</span></span>' + removeLink('saved', k) + '</div>';
      }).join('');
    }
    // This week: continue learning
    var last = st.prog.__last, cur = st.cur;
    root.querySelectorAll('[data-mk-resume]').forEach(function (resume) {
      if (!(cur || (last && last.url))) {
        resume.innerHTML = '<p class="mk-empty">Start a free course and your next lesson will wait here. <a href="' + esc(ACADEMY_URL) + '">Browse the Academy</a>.</p>';
        return;
      }
      var title = cur ? cur.next.n : last.title, url = cur ? cur.next.u : last.url;
      var sub = cur ? cur.c.n + ' \u00b7 lesson ' + (cur.done + 1) + ' of ' + cur.n : 'Pick up where you left off';
      resume.innerHTML = '<div class="mk-resume2">' + thumb('lesson', 'Lesson', cur && cur.next.th) + '<span class="mk-grow"><strong>' + esc(title) + '</strong><span>' + esc(sub) + '</span>' +
        (cur ? '<span class="mk-bar" role="img" aria-label="' + cur.done + ' of ' + cur.n + ' lessons done"><i style="width:' + Math.round(100 * cur.done / cur.n) + '%"></i></span>' : '') +
        '</span></div><div><a class="mk-btn mk-btn--sm mk-btn--solid" href="' + esc(url) + '">Resume lesson</a></div>';
    });
  }

  /* ---------- recipe submissions ---------- */
  var STEPS = ['Received', 'In review', 'Published'];
  function statusPill(s) {
    var cls = s === 'Published' ? 'ok' : s === 'In review' ? 'warn' : '';
    return '<span class="mk-pill' + (cls ? ' mk-pill--' + cls : '') + '">' + esc(s) + '</span>';
  }
  function drawSubmissions() {
    var box = root.querySelector('[data-mk-list="submissions"]'), subs = (me.activity() || {}).submissions || [];
    if (!box) return subs;
    if (!subs.length) {
      box.innerHTML = '<p class="mk-empty">You haven\'t shared a recipe yet. Send us a family favorite and follow it from our test kitchen to the site, with your name on it.</p>';
      return subs;
    }
    box.innerHTML = subs.map(function (s) {
      var status = s.status || 'Received', at = STEPS.indexOf(status), declined = status === 'Not accepted';
      var bar = declined ? '' : '<div class="mk-status">' + STEPS.map(function (step, i) {
        return '<span class="' + (i < at || status === 'Published' ? 'done' : i === at ? 'now' : '') + '">' + step + '</span>';
      }).join('') + '</div>';
      return '<div class="mk-card"><div class="mk-cardhead"><h3>' + esc(s.title) + '</h3>' + statusPill(status) + '</div>' +
        '<p class="mk-sub">Submitted ' + esc(fmtDate(s.submitted)) + (s.category ? ' \u00b7 ' + esc(s.category) : '') + '</p>' + bar +
        (s.note ? '<p class="mk-quote"><strong>From our test kitchen:</strong> ' + esc(s.note) + '</p>' : '') +
        (s.url ? '<div class="mk-actions"><a class="mk-btn mk-btn--sm" href="' + esc(s.url) + '">View recipe</a></div>' : '') + '</div>';
    }).join('');
    return subs;
  }

  var form = root.querySelector('[data-mk-submit-form]');
  function formMsg(text, bad) { var el = root.querySelector('[data-mk-form-msg]'); if (el) { el.textContent = text; el.classList.toggle('is-bad', !!bad); } }
  if (form) {
    var catSel = form.querySelector('[data-mk-categories]');
    if (catSel) catSel.innerHTML = CATEGORIES.map(function (c) { return '<option>' + esc(c) + '</option>'; }).join('');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = form.elements, v = function (n) { return (f[n] && f[n].value || '').trim(); };
      var recipe = { title: v('title'), category: v('category'), servings: v('servings'), time: v('time'), vanilla: v('vanilla'),
                     ingredients: v('ingredients'), steps: v('steps'), story: v('story'), tips: v('tips'), name: v('name'), agree: !!(f.agree && f.agree.checked) };
      var problem = recipe.title.length < 3 ? ['title', 'Add a recipe name.']
        : recipe.ingredients.length < 20 ? ['ingredients', 'List the ingredients, one per line.']
        : recipe.steps.length < 20 ? ['steps', 'Add the steps.']
        : !recipe.agree ? ['agree', 'Please confirm the recipe is yours to share.'] : null;
      if (problem) { formMsg(problem[1], true); if (f[problem[0]]) f[problem[0]].focus(); return; }
      if (typeof me.send !== 'function' || !me.syncing) { formMsg('Recipe sharing needs your account connection. Refresh the page and try again.', true); return; }
      var btn = form.querySelector('[type="submit"]');
      btn.disabled = true; formMsg('Sending your recipe...');
      me.send('submit', { recipe: recipe }).then(function (res) {
        btn.disabled = false;
        if (!res || !res.ok) { formMsg((res && res.error) || 'Could not send your recipe. Please try again.', true); return; }
        form.reset(); formMsg(''); form.hidden = true;
        track('recipe_submission', { category: recipe.category });
        drawAll();
        toast('Recipe sent. Thank you! We\'ll review it soon.');
      });
    });
  }

  /* ---------- reviews and comments ---------- */
  var REVIEW_THUMB = { recipe: ['recipe', 'Recipe'], article: ['journal', 'Article'], market: ['market', 'Market'], product: ['extract', 'Product'] };
  function stars(n) { n = Math.max(0, Math.min(5, Number(n) || 0)); return n ? '\u2605\u2605\u2605\u2605\u2605'.slice(0, n) + '\u2606\u2606\u2606\u2606\u2606'.slice(0, 5 - n) + ' ' : ''; }
  function drawReviews() {
    var box = root.querySelector('[data-mk-list="reviews"]'), revs = (me.activity() || {}).reviews || [];
    if (!box) return revs;
    if (!revs.length) {
      box.innerHTML = '<p class="mk-empty">Comments you leave on recipes and journal articles, and reviews of farmers markets, will be listed here.</p>';
      return revs;
    }
    box.innerHTML = '<div class="mk-card">' + revs.map(function (r) {
      var t = REVIEW_THUMB[r.type] || REVIEW_THUMB.recipe;
      var head = r.rating ? '<span class="mk-stars" aria-label="' + r.rating + ' out of 5 stars">' + stars(r.rating) + '</span>on ' : (r.type === 'market' ? 'Review of ' : 'Comment on ');
      var title = r.url ? '<a href="' + esc(r.url) + '">' + esc(r.title) + '</a>' : esc(r.title);
      var pill = r.status === 'Published' ? 'mk-pill--ok' : r.status === 'Awaiting approval' ? 'mk-pill--warn' : '';
      return '<div class="mk-row">' + thumb(t[0], t[1]) + '<span class="mk-grow"><strong>' + head + title + '</strong><span>' +
        (r.text ? '"' + esc(r.text.length > 160 ? r.text.slice(0, 157) + '...' : r.text) + '" \u00b7 ' : '') + esc(fmtDate(r.date)) + '</span></span>' +
        '<span class="mk-pill ' + pill + '">' + esc(r.status || 'Received') + '</span></div>';
    }).join('') + '</div>';
    return revs;
  }

  /* ---------- avatar ---------- */
  function initialsOf(p) {
    var name = String(p.name || (root.querySelector('[data-mk-name-line]') || {}).textContent || '').trim();
    var parts = name.split(/\s+/).filter(Boolean);
    return parts.length ? (parts[0].charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '')).toUpperCase()
      : ((root.querySelector('[data-mk-avatar]') || {}).textContent || '?').trim().slice(0, 2);
  }
  var baseInitials = '';
  function avatarHtml(av, p) {
    av = av || {};
    if (av.kind === 'photo' && p.photo) return '<img src="' + esc(sized(p.photo, 240)) + '" alt="">';
    if (av.kind === 'icon' && ICONS[av.icon]) return '<svg aria-hidden="true" viewBox="0 0 24 24">' + ICONS[av.icon] + '</svg>';
    return esc(p.name ? initialsOf(p) : baseInitials);
  }
  function paintAvatars(av, p) {
    var c = COLORS[(av && av.color) || 'gold'] || COLORS.gold;
    root.querySelectorAll('[data-mk-avatar]').forEach(function (el) {
      el.innerHTML = avatarHtml(av, p);
      el.style.background = av && av.kind === 'photo' && p.photo ? '#fff' : c[0];
      el.style.color = c[1];
    });
  }

  /* ---------- profile editor ---------- */
  var pform = root.querySelector('[data-mk-profile-form]');
  var draft = { avatar: { kind: 'initials', icon: '', color: 'gold' }, top5: [] };
  function chipsHtml(items, mine, attr) {
    return items.map(function (c) {
      return '<button type="button" class="mk-chip" ' + attr + '="' + esc(c) + '" aria-pressed="' + (mine.indexOf(c) > -1) + '">' + esc(c.replace('Cafe', 'Caf\u00e9')) + '</button>';
    }).join('');
  }
  function fillChips(name, items, mine) {
    root.querySelectorAll('[data-mk-chips="' + name + '"]').forEach(function (box) { box.innerHTML = chipsHtml(items, mine || [], 'data-mk-chip'); });
  }
  function chosen(name) {
    var box = root.querySelector('[data-mk-chips="' + name + '"]');
    return box ? Array.prototype.map.call(box.querySelectorAll('[aria-pressed="true"]'), function (b) { return b.getAttribute('data-mk-chip'); }) : [];
  }
  function setTog(el, on) { if (el) el.setAttribute('aria-checked', on ? 'true' : 'false'); }
  function isOn(el) { return !!el && el.getAttribute('aria-checked') === 'true'; }
  function slugify(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 30); }
  function field(id) { return root.querySelector('#' + id); }
  function drawIcons() {
    var box = root.querySelector('[data-mk-icons]'), cbox = root.querySelector('[data-mk-colors]');
    if (box && !box.children.length) box.innerHTML = Object.keys(ICONS).map(function (k) {
      return '<button type="button" class="mk-icon" data-mk-icon="' + k + '" aria-pressed="false" aria-label="' + k + ' icon"><svg aria-hidden="true" viewBox="0 0 24 24">' + ICONS[k] + '</svg></button>';
    }).join('');
    if (cbox && !cbox.children.length) cbox.innerHTML = Object.keys(COLORS).map(function (k) {
      return '<button type="button" class="mk-swatch" data-mk-color="' + k + '" aria-pressed="false" aria-label="' + k + '" style="background:' + COLORS[k][0] + '"></button>';
    }).join('');
    root.querySelectorAll('[data-mk-icon]').forEach(function (b) { b.setAttribute('aria-pressed', draft.avatar.kind === 'icon' && draft.avatar.icon === b.getAttribute('data-mk-icon') ? 'true' : 'false'); });
    root.querySelectorAll('[data-mk-color]').forEach(function (b) { b.setAttribute('aria-pressed', draft.avatar.color === b.getAttribute('data-mk-color') ? 'true' : 'false'); });
  }
  function drawTop5() {
    var box = root.querySelector('[data-mk-top5]');
    if (!box) return;
    box.innerHTML = draft.top5.length ? draft.top5.map(function (r, i) {
      return '<li class="mk-t5">' + thumb('recipe', '', r.i ? sized(r.i, 120) : '') + '<span class="mk-grow"><strong>' + esc(r.n) + '</strong></span>' +
        '<span class="mk-t5-acts"><button type="button" class="mk-iconbtn" data-mk-t5-up="' + i + '" aria-label="Move ' + esc(r.n) + ' up"' + (i ? '' : ' disabled') + '>&#8593;</button>' +
        '<button type="button" class="mk-iconbtn" data-mk-t5-down="' + i + '" aria-label="Move ' + esc(r.n) + ' down"' + (i < draft.top5.length - 1 ? '' : ' disabled') + '>&#8595;</button>' +
        '<button type="button" class="mk-iconbtn" data-mk-t5-x="' + i + '" aria-label="Remove ' + esc(r.n) + '">&times;</button></span></li>';
    }).join('') : '<li class="mk-empty mk-t5-empty">No favorites yet. Search below or pick from recipes you\'ve saved and baked.</li>';
    var add = root.querySelector('[data-mk-top5-add]');
    if (add) add.hidden = draft.top5.length >= 5;
    var quick = root.querySelector('[data-mk-top5-quick]');
    if (quick) {
      var have = draft.top5.map(function (r) { return r.id; }), seen = {}, opts = [];
      var bakes = list(K.bakes);
      Object.keys(bakes).forEach(function (id) { if (bakes[id].u && /\/blogs\/recipes\//.test(bakes[id].u)) opts.push({ id: id, n: bakes[id].n, u: bakes[id].u, i: bakes[id].i }); });
      articles().recipes.forEach(function (a) { if (a.m) opts.push({ id: a.id, n: a.m.n, u: a.m.u, i: a.m.i }); });
      opts = opts.filter(function (o) { if (seen[o.id] || have.indexOf(o.id) > -1 || !/^\d+$/.test(o.id)) return false; seen[o.id] = 1; return true; }).slice(0, 6);
      quick.innerHTML = opts.length ? '<p class="mk-sub">From your bakes and saves:</p><div class="mk-chips">' + opts.map(function (o) {
        return '<button type="button" class="mk-chip" data-mk-t5-pick="' + esc(o.id) + '" data-n="' + esc(o.n) + '" data-u="' + esc(o.u) + '" data-i="' + esc(o.i || '') + '">+ ' + esc(o.n) + '</button>';
      }).join('') + '</div>' : '';
    }
  }
  function updateHints() {
    var h = field('mk-p-handle'), hint = root.querySelector('[data-mk-handle-hint]');
    if (h && hint) hint.textContent = 'vanillagoods.com/pages/baker/' + (slugify(h.value) || 'your-name');
    var bio = field('mk-p-bio'), bc = root.querySelector('[data-mk-bio-count]');
    if (bio && bc) bc.textContent = (160 - bio.value.length) + ' characters left';
    var pub = root.querySelector('[data-mk-public]'), ph = root.querySelector('[data-mk-public-hint]');
    if (ph) ph.textContent = isOn(pub) ? 'On. Anyone with your link can see the parts you choose.' : 'Off. Only you can see your profile.';
  }
  function loadProfileForm() {
    var p = me.profile() || {};
    if (!pform) return p;
    draft.avatar = { kind: (p.avatar && p.avatar.kind) || 'initials', icon: (p.avatar && p.avatar.icon) || '', color: (p.avatar && p.avatar.color) || 'gold' };
    draft.top5 = (p.top5 || []).slice(0, 5);
    var set = function (id, v) { var el = field(id); if (el && document.activeElement !== el && v != null && v !== '') el.value = v; };
    set('mk-p-name', p.name); set('mk-p-handle', p.handle); set('mk-p-city', p.city); set('mk-p-bio', p.bio);
    set('mk-p-sig', p.signature); set('mk-p-vanilla', p.vanilla); set('mk-skill', p.skill);
    set('mk-p-since', p.bakingSince); set('mk-p-goal', p.goal);
    if (!p.handle && field('mk-p-handle') && !field('mk-p-handle').value) field('mk-p-handle').value = slugify((field('mk-p-name') || {}).value || '').replace(/-/g, '');
    Object.keys(SOCIAL).forEach(function (k) { set('mk-s-' + k, (p.socials || {})[k]); });
    fillChips('flavors', FLAVORS, p.flavors); fillChips('loves', LOVES, p.loves); fillChips('diets', DIETS, p.diets);
    var ib = root.querySelector('[data-mk-interests]');
    if (ib) ib.innerHTML = chipsHtml(INTERESTS, p.interests || [], 'data-mk-interest');
    setTog(root.querySelector('[data-mk-public]'), !!p.public);
    setTog(root.querySelector('[data-mk-indexable]'), !!p.indexable);
    var show = p.show || { about: true, top5: true, style: true, badges: true, social: true };
    root.querySelectorAll('[data-mk-show]').forEach(function (t) { setTog(t, !!show[t.getAttribute('data-mk-show')]); });
    var pr = p.prefs || {};
    root.querySelectorAll('[data-mk-pref]').forEach(function (t) { setTog(t, !!pr[t.getAttribute('data-mk-pref')]); });
    root.querySelectorAll('[data-mk-pick]').forEach(function (s) { var k = s.getAttribute('data-mk-pick'); if (pr[k] != null && document.activeElement !== s) s.value = String(pr[k]); });
    set('mk-p-state', p.state);
    fillCountries();
    var csel = field('mk-p-country');
    if (csel && document.activeElement !== csel) csel.value = p.country && countryNames[p.country] ? p.country : 'US';
    set('mk-p-region', p.region); set('mk-p-postal', p.postal);
    drawLocation();
    fillChips('equipment', EQUIP, pr.equipment); fillChips('goals', GOALS, pr.goals); fillChips('formats', FORMATS, pr.formats);
    drawIcons(); drawTop5(); updateHints();
    paintAvatars(draft.avatar, p);
    return p;
  }
  function statsNow() {
    var st = academyState(), ms = milestones(st);
    return { bakes: bakeTotal(), lessons: ms.lessons, courses: ms.done.length,
             badges: ms.list.filter(function (x) { return x.got; }).map(function (x) { return x.k; }) };
  }
  /* ---------- round 2 (Oct 2026): recipe collections (saved on the profile) and bakers you follow ---------- */
  var colDraft = null;
  function cols() { return colDraft || (me.profile() || {}).collections || []; }
  function savedOptions(skip) {
    var a = articles().recipes.filter(function (x) { return x.m && skip.indexOf(String(x.id)) === -1; });
    return a.map(function (x) { return '<option value="' + esc(x.id) + '">' + esc(x.m.n) + '</option>'; }).join('');
  }
  function drawCollections() {
    var box = root.querySelector('[data-mk-cols]'), list = cols();
    setCount('collections', list.length);
    if (!box) return;
    if (!list.length) { box.innerHTML = '<p class="mk-empty">No collections yet. Name one above, then add recipes you\'ve saved with the heart.</p>'; return; }
    box.innerHTML = list.map(function (c, ci) {
      var ids = (c.r || []).map(function (r) { return String(r.id); }), opts = savedOptions(ids);
      return '<div class="mk-card mk-col" data-mk-col="' + ci + '"><div class="mk-cardhead"><h2>' + esc(c.t) + ' <span class="mk-sub">(' + ids.length + ')</span></h2>' +
        '<button type="button" class="mk-link" data-mk-col-del="' + ci + '">Delete</button></div>' +
        '<label class="mk-col-pub"><input type="checkbox" data-mk-col-pub="' + ci + '"' + (c.pub ? ' checked' : '') + '> Show on my baker page</label>' +
        (ids.length ? '<ul class="mk-col-list">' + (c.r || []).map(function (r) {
          return '<li><a href="' + esc(r.u) + '">' + esc(r.n) + '</a><button type="button" class="mk-link" data-mk-col-rm="' + ci + ':' + esc(r.id) + '" aria-label="Remove ' + esc(r.n) + '">Remove</button></li>';
        }).join('') + '</ul>' : '<p class="mk-sub">No recipes yet.</p>') +
        (ids.length < 12 ? (opts ? '<label class="mk-col-add">Add a saved recipe<select data-mk-col-add="' + ci + '"><option value="">Choose a recipe</option>' + opts + '</select></label>'
          : '<p class="mk-sub">Save recipes with the heart to add them here.</p>') : '<p class="mk-sub">This collection is full (12 recipes).</p>') +
        '</div>';
    }).join('');
  }
  function saveCollections(next, what) {
    colDraft = next;
    drawCollections();
    var msg = root.querySelector('[data-mk-col-msg]');
    saveProfile(msg);
    track('collection_' + what, { count: next.length });
  }
  function drawFollows() {
    var box = root.querySelector('[data-mk-follows]');
    if (!box) return;
    var f = list('vg_follows_v1'), hs = Object.keys(f).sort(function (a, b) { return String(f[b].d || '').localeCompare(String(f[a].d || '')); });
    box.innerHTML = '<div class="mk-cardhead"><h2>Bakers you follow</h2>' + (hs.length ? '<span class="mk-sub">' + hs.length + '</span>' : '') + '</div>' +
      (hs.length ? '<ul class="mk-follow-list">' + hs.map(function (h) {
        var x = f[h] || {};
        return '<li><a href="/pages/baker/' + esc(h) + '"><span class="mk-avatar mk-avatar--sm">' + (x.p ? '<img src="' + esc(x.p) + '" alt="" width="36" height="36">' : esc(x.ini || '?')) + '</span>' +
          '<span><strong>' + esc(x.n || h) + '</strong><small>@' + esc(h) + '</small></span></a></li>';
      }).join('') + '</ul>' : '<p class="mk-sub">Find bakers through the photos on recipe pages, then tap Follow on their page to keep them here.</p>');
  }
  root.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('[data-mk-col-new]')) return;
    e.preventDefault();
    var inp = field('mk-col-name'), t = (inp.value || '').trim().slice(0, 40), list0 = cols().slice();
    var msg = root.querySelector('[data-mk-col-msg]');
    if (!t) { msg.textContent = 'Name your collection first.'; inp.focus(); return; }
    if (list0.length >= 6) { msg.textContent = 'You can have up to 6 collections.'; return; }
    inp.value = '';
    saveCollections(list0.concat([{ t: t, pub: false, r: [] }]), 'create');
  });
  root.addEventListener('change', function (e) {
    var t = e.target, ci;
    if (t.hasAttribute && t.hasAttribute('data-mk-col-pub')) {
      ci = Number(t.getAttribute('data-mk-col-pub'));
      saveCollections(cols().map(function (c, i) { return i === ci ? { t: c.t, pub: t.checked, r: c.r || [] } : c; }), 'share');
    } else if (t.hasAttribute && t.hasAttribute('data-mk-col-add') && t.value) {
      ci = Number(t.getAttribute('data-mk-col-add'));
      var hit = articles().recipes.filter(function (x) { return String(x.id) === t.value; })[0];
      if (!hit || !hit.m) return;
      saveCollections(cols().map(function (c, i) {
        return i === ci ? { t: c.t, pub: c.pub, r: (c.r || []).concat([{ id: String(hit.id), n: hit.m.n, u: hit.m.u, i: hit.m.i || '' }]) } : c;
      }), 'add');
    }
  });
  root.addEventListener('click', function (e) {
    var d = e.target.closest && e.target.closest('[data-mk-col-del],[data-mk-col-rm]');
    if (!d) return;
    if (d.hasAttribute('data-mk-col-del')) {
      var di = Number(d.getAttribute('data-mk-col-del'));
      if (!window.confirm('Delete the collection "' + cols()[di].t + '"? Your saved recipes stay saved.')) return;
      saveCollections(cols().filter(function (c, i) { return i !== di; }), 'delete');
    } else {
      var parts = d.getAttribute('data-mk-col-rm').split(':'), ri = Number(parts[0]);
      saveCollections(cols().map(function (c, i) { return i === ri ? { t: c.t, pub: c.pub, r: (c.r || []).filter(function (r) { return String(r.id) !== parts[1]; }) } : c; }), 'remove');
    }
  });

  function collect() {
    var v = function (id) { var el = field(id); return el ? el.value.trim() : ''; };
    var socials = {};
    Object.keys(SOCIAL).forEach(function (k) { var s = v('mk-s-' + k); if (s) socials[k] = s; });
    var show = {};
    root.querySelectorAll('[data-mk-show]').forEach(function (t) { show[t.getAttribute('data-mk-show')] = isOn(t); });
    var prefs = {};
    root.querySelectorAll('[data-mk-pref]').forEach(function (t) { prefs[t.getAttribute('data-mk-pref')] = isOn(t); });
    root.querySelectorAll('[data-mk-pick]').forEach(function (s) { if (s.value) prefs[s.getAttribute('data-mk-pick')] = s.value; });
    prefs.equipment = chosen('equipment'); prefs.goals = chosen('goals'); prefs.formats = chosen('formats');
    return {
      v: 4, skill: v('mk-skill'), name: v('mk-p-name'), handle: slugify(v('mk-p-handle')), city: v('mk-p-city'), state: (v('mk-p-country') || 'US') === 'US' ? v('mk-p-state') : '', bio: v('mk-p-bio'),
      country: v('mk-p-country') || 'US', countryName: countryNames[v('mk-p-country') || 'US'] || '',
      region: (v('mk-p-country') || 'US') === 'US' ? '' : v('mk-p-region'),
      postal: (locOf(v('mk-p-country') || 'US').postal ? v('mk-p-postal').toUpperCase() : ''),
      bakingSince: v('mk-p-since'), goal: v('mk-p-goal'),
      signature: v('mk-p-sig'), vanilla: v('mk-p-vanilla'), flavors: chosen('flavors'), loves: chosen('loves'), diets: chosen('diets'),
      interests: Array.prototype.map.call(root.querySelectorAll('[data-mk-interest][aria-pressed="true"]'), function (b) { return b.getAttribute('data-mk-interest'); }),
      avatar: draft.avatar, socials: socials, top5: draft.top5.map(function (r) { return r.id; }), show: show, prefs: prefs,
      public: isOn(root.querySelector('[data-mk-public]')), indexable: isOn(root.querySelector('[data-mk-indexable]')), stats: statsNow(),
      collections: colDraft ? colDraft.map(function (c) { return { t: c.t, pub: !!c.pub, ids: (c.r || []).map(function (r) { return String(r.id); }) }; }) : undefined
    };
  }
  function saveProfile(msgEl, btn) {
    var profile = collect();
    function say(t, bad) { if (msgEl) { msgEl.textContent = t; msgEl.classList.toggle('is-bad', !!bad); } }
    if (typeof me.send !== 'function' || !me.syncing) { say('Saving needs your account connection. Refresh the page and try again.', true); return; }
    if (profile.public && !profile.name) { say('Add a display name to share your profile.', true); field('mk-p-name').focus(); return; }
    if (profile.public && profile.handle.length < 3) { say('Choose a profile address of at least 3 letters or numbers.', true); field('mk-p-handle').focus(); return; }
    if (btn) btn.disabled = true;
    say('Saving...');
    me.send('profile', { profile: profile }).then(function (res) {
      if (btn) btn.disabled = false;
      if (!res || !res.ok) { say((res && res.error) || 'Could not save. Please try again.', true); return; }
      var saved = res.profile || {};
      if ((Number(me.api) || 0) < 4 && saved.name === undefined) {
        say('Saved your skill level and interests. The rest of your profile will save once our update finishes rolling out.', false);
      } else {
        say(saved.public && saved.url ? 'Saved. Your public profile is live.' : 'Profile saved.');
      }
      track('profile_saved', { public: !!saved.public });
      afterProfile();
    });
  }
  function afterProfile() { colDraft = null; loadProfileForm(); drawSideProfile(); drawPublic(); drawPicked(true); drawRound1(); drawCollections(); }
  if (pform) {
    pform.addEventListener('submit', function (e) { e.preventDefault(); saveProfile(pform.querySelector('[data-mk-profile-msg]'), pform.querySelector('[type="submit"]')); });
    pform.addEventListener('change', function (e) {
      if (e.target.id === 'mk-p-country') {
        drawLocation();
        var un = field('mk-f-units');
        if (un && !un.value && e.target.value !== 'US') un.value = 'grams';   // grams by default outside the US; still changeable
      }
      if (e.target.id === 'mk-p-postal') postalFill();
    });
    pform.addEventListener('input', function (e) {
      if (e.target.id === 'mk-p-handle' || e.target.id === 'mk-p-bio') updateHints();
      if (e.target.id === 'mk-p-postal') checkPostal();
      if (e.target.id === 'mk-p-name' && draft.avatar.kind === 'initials') paintAvatars(draft.avatar, { name: e.target.value });
    });
  }
  root.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-mk-ask-pick]');
    if (!s || !s.value) return;
    var src = root.querySelector('[data-mk-pick="' + s.getAttribute('data-mk-ask-pick') + '"]');
    if (src) src.value = s.value;
    track('profile_question', { question: s.getAttribute('data-mk-ask-pick') });
    saveProfile(root.querySelector('[data-mk-ask-msg]'));
  });
  root.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('[data-mk-focus]');
    if (!f) return;
    var id = f.getAttribute('data-mk-focus');
    setTimeout(function () { var el = field(id); if (el) { el.scrollIntoView({ block: 'center' }); try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); } } }, 80);
  });
  var prefsBtn = root.querySelector('[data-mk-save-prefs]');
  if (prefsBtn) prefsBtn.addEventListener('click', function () { saveProfile(root.querySelector('[data-mk-prefs-msg]'), prefsBtn); });

  /* top 5 search (Shopify's predictive search) */
  function searchBox(input, results, onPick) {
    if (!input || !results) return;
    var t = null;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        suggest(q, 'article').then(function (res) {
          var hits = (res || []).filter(function (a) { return /\/blogs\/recipes\//.test(a.url || ''); }).slice(0, 6);
          results.innerHTML = hits.length ? hits.map(function (a) {
            return '<button type="button" role="option" class="mk-result" data-id="' + esc(a.id) + '" data-n="' + esc(a.title) + '" data-u="' + esc(String(a.url).split('?')[0]) + '" data-i="' + esc(a.image || '') + '">' +
              thumb('recipe', '', a.image ? sized(a.image, 80) : '') + '<span>' + esc(a.title) + '</span></button>';
          }).join('') : '<p class="mk-sub">No recipes match "' + esc(q) + '".</p>';
        });
      }, 220);
    });
    results.addEventListener('click', function (e) {
      var b = e.target.closest('.mk-result');
      if (!b) return;
      onPick({ id: String(b.getAttribute('data-id')), n: b.getAttribute('data-n'), u: b.getAttribute('data-u'), i: b.getAttribute('data-i') });
      input.value = ''; results.innerHTML = '';
    });
  }
  searchBox(root.querySelector('[data-mk-top5-q]'), root.querySelector('[data-mk-top5-results]'), function (r) {
    if (draft.top5.length >= 5 || draft.top5.some(function (x) { return x.id === r.id; })) return;
    draft.top5.push(r); drawTop5();
  });
  searchBox(root.querySelector('[data-mk-plan-q]'), root.querySelector('[data-mk-plan-results]'), function (r) {
    if (!list(K.plan)[r.id]) planToggle(r.id, r.n, r.u, r.i);
    drawAll();
    toast('Added ' + esc(r.n) + ' to your week.');
  });

  /* profile photo: resized to 480px in the browser, then sent to the sync service */
  var photoIn = root.querySelector('[data-mk-photo]');
  if (photoIn) photoIn.addEventListener('change', function () {
    var file = photoIn.files && photoIn.files[0], msg = root.querySelector('[data-mk-photo-msg]');
    function say(t, bad) { if (msg) { msg.textContent = t; msg.classList.toggle('is-bad', !!bad); } }
    if (!file) return;
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) { say('Choose a JPG, PNG or WebP photo.', true); return; }
    if ((Number(me.api) || 0) < 4) { say('Photo uploads switch on once our update finishes rolling out. Pick a baking icon for now.', true); return; }
    say('Getting your photo ready...');
    var img = new Image(), url = URL.createObjectURL(file);
    img.onload = function () {
      var s = Math.min(img.width, img.height), c = document.createElement('canvas');
      c.width = c.height = Math.min(480, s);
      c.getContext('2d').drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var data = c.toDataURL('image/jpeg', 0.85);
      say('Uploading...');
      me.send('photo', { image: data }).then(function (res) {
        photoIn.value = '';
        if (!res || !res.ok) { say((res && res.error) || 'Could not upload. Please try again.', true); return; }
        draft.avatar = res.profile.avatar || { kind: 'photo', color: 'gold' };
        say('Photo saved.');
        afterProfile();
      });
    };
    img.onerror = function () { say('That file could not be read as a photo.', true); };
    img.src = url;
  });

  /* sidebar: name, skill, public link */
  function drawSideProfile() {
    var p = me.profile() || {};
    var line = root.querySelector('[data-mk-skill-line]');
    if (line) line.textContent = (p.handle && p.public ? '@' + p.handle + ' \u00b7 ' : '') + (p.skill || 'VanillaGoods member');
    var nl = root.querySelector('[data-mk-name-line]');
    if (nl && p.name) nl.textContent = p.name;
    var box = root.querySelector('[data-mk-publink]'), dot = root.querySelector('[data-mk-public-dot]');
    if (dot) dot.hidden = !(p.public && p.url);
    if (box) {
      box.hidden = false;
      box.innerHTML = p.public && p.url
        ? '<strong>Your public profile is on</strong><code>' + esc(p.url.replace(/^https?:\/\//, '')) + '</code><span class="mk-actions"><a class="mk-link" href="' + esc(p.url) + '" target="_blank" rel="noopener">View it</a><button type="button" class="mk-link" data-mk-share-profile>Copy link</button></span>'
        : '<strong>Share your baking</strong><span>Get your own page with your top 5 recipes and badges.</span><button type="button" class="mk-link" data-mk-go="profile">Set up my profile</button>';
    }
    paintAvatars(draft.avatar, p);
  }

  /* public profile preview (the same layout as /pages/baker/<handle>) */
  function drawPublic() {
    var box = root.querySelector('[data-mk-public-preview]');
    if (!box) return;
    var p = me.profile() || {}, live = collect(), show = live.show;
    var line = root.querySelector('[data-mk-public-line]'), share = root.querySelector('.mk-phead [data-mk-share-profile]');
    if (line) line.innerHTML = p.public && p.url ? 'Live at <a href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.url.replace(/^https?:\/\//, '')) + '</a>. Your published recipes link here too.'
      : 'This is a preview. Turn on <strong>Share my profile</strong> in <button type="button" class="mk-link" data-mk-go="profile">My profile</button> to publish it.';
    if (share) share.hidden = !(p.public && p.url);
    var st = statsNow(), avatar = show.about ? draft.avatar : { kind: 'initials', color: draft.avatar.color };
    var c = COLORS[avatar.color] || COLORS.gold;
    var facts = [];
    if (show.style && live.signature) facts.push(['Signature bake', live.signature]);
    if (show.style && live.vanilla) facts.push(['Favorite vanilla', live.vanilla]);
    if (show.style && live.flavors.length) facts.push(['Go-to flavors', live.flavors.join(', ')]);
    if (show.style && live.loves.length) facts.push(['Loves baking', live.loves.join(', ').replace('Cafe', 'Caf\u00e9')]);
    var socials = show.social ? Object.keys(live.socials).map(function (k) { return '<span class="mk-soc" title="' + SOCIAL[k][1] + '">' + SOCIAL[k][0] + '</span>'; }).join('') : '';
    var bakes = list(K.bakes), recent = Object.keys(bakes).map(function (k) { return bakes[k]; }).filter(function (b) { return b.c && b.u; })
      .sort(function (a, b) { return String(b.d || '').localeCompare(String(a.d || '')); }).slice(0, 6);
    box.innerHTML = '<article class="mk-pub">' +
      '<div class="mk-pub-cover"></div>' +
      '<div class="mk-pub-head"><span class="mk-avatar mk-avatar--pub" style="background:' + (avatar.kind === 'photo' && p.photo ? '#fff' : c[0]) + ';color:' + c[1] + '">' + avatarHtml(avatar, { name: live.name, photo: p.photo }) + '</span>' +
      '<div class="mk-grow"><h2>' + esc(live.name || 'Your name') + '</h2><p class="mk-pub-handle">@' + esc(live.handle || 'your-name') + (live.skill ? ' \u00b7 ' + esc(live.skill) : '') + (show.city && (live.city || live.state || live.region) ? ' \u00b7 ' + esc([live.city, live.state || live.region, live.country && live.country !== 'US' ? live.countryName : ''].filter(Boolean).join(', ')) : '') + (show.about && live.bakingSince ? ' \u00b7 Baking since ' + esc(live.bakingSince) : '') + '</p>' +
      (socials ? '<div class="mk-socs">' + socials + '</div>' : '') + '</div></div>' +
      '<div class="mk-pub-body">' +
      (show.about && live.bio ? '<p class="mk-pub-bio">' + esc(live.bio) + '</p>' : '') +
      (show.badges ? '<div class="mk-pub-stats"><div><b>' + st.bakes + '</b><span>' + (st.bakes === 1 ? 'bake' : 'bakes') + ' logged</span></div><div><b>' + st.badges.length + '</b><span>' + (st.badges.length === 1 ? 'badge' : 'badges') + ' earned</span></div><div><b>' + st.courses + '</b><span>' + (st.courses === 1 ? 'course' : 'courses') + ' finished</span></div></div>' : '') +
      (show.top5 && draft.top5.length ? '<div class="mk-pub-sec"><h3>Top 5 recipes</h3><ol class="mk-pub-five">' + draft.top5.map(function (r, i) {
        return '<li><a href="' + esc(r.u) + '">' + thumb('recipe', '', r.i ? sized(r.i, 300) : '') + '<span class="mk-rank">' + (i + 1) + '</span><strong>' + esc(r.n) + '</strong></a></li>';
      }).join('') + '</ol></div>' : '') +
      (facts.length ? '<div class="mk-pub-facts">' + facts.map(function (f) { return '<div><small>' + esc(f[0]) + '</small><strong>' + esc(f[1]) + '</strong></div>'; }).join('') + '</div>' : '') +
      (show.badges && st.badges.length ? '<div class="mk-pub-sec"><h3>Badges</h3><div class="mk-chips">' + st.badges.map(function (b) { return '<span class="mk-pill mk-pill--gold">' + esc(BADGE_NAMES[b] || b) + '</span>'; }).join('') + '</div></div>' : '') +
      (show.bakes && recent.length ? '<div class="mk-pub-sec"><h3>Recent bakes</h3>' + recent.map(function (b) {
        return '<div class="mk-row">' + thumb('recipe', '', b.i) + '<span class="mk-grow"><strong><a href="' + esc(b.u) + '">' + esc(b.n) + '</a></strong><span>' + esc(b.d ? 'Baked ' + shortDay(b.d) : '') + (b.r ? ' \u00b7 ' + starText(b.r) : '') + '</span></span></div>';
      }).join('') + '</div>' : '') +
      '</div></article>';
  }

  /* ---------- picks for this week (seeded by the week, so they change on Monday) ---------- */
  var pickedCache = {};
  function suggest(q, type) {
    var key = type + ':' + q;
    if (pickedCache[key]) return pickedCache[key];
    pickedCache[key] = fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=' + type + '&resources[limit]=10')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.resources && d.resources.results && d.resources.results[type + 's']) || []; })
      .catch(function () { return []; });
    return pickedCache[key];
  }
  var BROWSE_OF_LOVE = { Pies: 'Pies & Tarts', Bread: 'Breakfast & Brunch Bakes', Cookies: 'Cookies & Bars', Cakes: 'Cakes & Cupcakes', Cheesecakes: 'Cheesecakes',
                         'Ice cream': 'Ice Cream & Frozen Treats', Doughnuts: 'Doughnuts', Pastry: 'Pastries', Custards: 'Custards & Puddings', Candy: 'Candy & Confections',
                         'Cafe drinks': 'Coffee, Lattes & Cold Brew', Tea: 'Tea, Chai & Matcha' };
  var DIET_TAG = { 'Gluten-free': 'Gluten-Free', 'Dairy-free': 'Dairy-Free', Vegan: 'Vegan', 'Egg-free': 'Egg-Free', 'Nut-free': 'No Tree Nuts' };
  function tsq(v) { return '`' + String(v).replace(/`/g, '') + '`'; }
  function seasonFilter() {
    var m = NOW.getMonth();
    if (m >= 8 && m <= 10) return 'season:=Fall';
    if (m === 11) return 'season:=Holiday';
    if (m >= 5 && m <= 7) return 'season:=Summer';
    if (m >= 2 && m <= 4) return 'occasions:=Spring';
    return '';
  }
  /* Picks that learn: what you save and make (by category), what you said you love, the season, your diet and weeknight
     time; a drink when you save or make drinks. Never a recipe you saved, made or planned. Reshuffled every Monday. */
  function drawPicked(force) {
    var box = root.querySelector('[data-mk-list="picked"]'), why = root.querySelector('[data-mk-picked-why]');
    if (!box || (box.getAttribute('data-done') && !force)) return;
    if (!TS.host || !TS.key) { drawPickedLegacy(force); return; }
    box.setAttribute('data-done', '1');
    var p = me.profile() || {}, pr = p.prefs || {}, rnd = seeded(weekNo * 97 + 13);
    var savedIds = list(K.recipes).map(String), bakes = list(K.bakes), bakedIds = Object.keys(bakes), planIds = Object.keys(list(K.plan));
    box.innerHTML = '<p class="mk-sub">Finding recipes for you...</p>';
    loadFacts(savedIds.concat(bakedIds)).then(function () {
      var cats = {}, drinkSignal = (p.loves || []).some(function (x) { return x === 'Cafe drinks' || x === 'Tea'; }) || (p.interests || []).some(function (x) { return /Coffee|Drinks/.test(x); });
      function count(id, w) { var f = facts[String(id)]; if (!f) return; if (f.browse) cats[f.browse] = (cats[f.browse] || 0) + w; if (f.kind === 'Drinks') drinkSignal = true; }
      savedIds.forEach(function (id) { count(id, 1); });
      bakedIds.forEach(function (id) { count(id, 2); });
      (p.loves || []).forEach(function (l) { var c = BROWSE_OF_LOVE[l]; if (c) cats[c] = (cats[c] || 0) + 1; });
      var top = Object.keys(cats).sort(function (a, b) { return cats[b] - cats[a]; });
      var exclude = savedIds.concat(bakedIds, planIds).filter(function (id, i, a) { return /^\d+$/.test(id) && a.indexOf(id) === i; }).slice(0, 200), base = [];
      if (exclude.length) base.push('id:!=[' + exclude.join(',') + ']');
      (p.diets || []).forEach(function (d) { if (DIET_TAG[d]) base.push('diets:=' + tsq(DIET_TAG[d])); });
      var t = Number(pr.time) || 0; if (t && t <= 30) base.push('active_minutes:<=' + (t + 15));
      var searches = [];
      function add(filter) {
        searches.push({ collection: TS.coll, q: '*', query_by: 'title', filter_by: base.concat(filter ? [filter] : []).join(' && '),
                        per_page: 12, page: 1 + Math.floor(rnd() * 3), include_fields: FACT_FIELDS, sort_by: 'published_at:desc' });
      }
      // one or two food categories you lean to, one drink category when drinks are your thing, the season, then any bake
      var DRINK_CAT = /^(Milkshakes|Smoothies|Coffee|Tea, Chai|Hot Chocolate|Syrups|Lemonades|Frapp)/;
      var topFood = top.filter(function (c) { return !DRINK_CAT.test(c); }), topDrink = top.filter(function (c) { return DRINK_CAT.test(c); });
      if (topFood[0]) add('browse:=' + tsq(topFood[0]));
      if (drinkSignal) add(topDrink[0] ? 'browse:=' + tsq(topDrink[0]) : 'kind:=Drinks');
      if (topFood[1]) add('browse:=' + tsq(topFood[1]));
      var sf = seasonFilter(); if (sf) add(sf + ' && kind:=Food');
      while (searches.length < 4) add('kind:=Food');
      tsFetch('/multi_search', { searches: searches }).then(function (res) {
        var results = (res && res.results) || [];
        if (!results.some(function (r) { return r && r.hits && r.hits.length; })) { drawPickedLegacy(true); return; }
        var pools = results.map(function (r) {
          var hits = (r.hits || []).map(function (h) { return h.document; }).filter(function (d) { return exclude.indexOf(String(d.id)) === -1; });
          for (var i = hits.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)), x = hits[i]; hits[i] = hits[j]; hits[j] = x; }
          return hits;
        });
        var picks = [], seen = {};
        for (var round = 0; round < 16 && picks.length < 4; round++) {
          var pool = pools[round % pools.length], d = pool.shift();
          if (!d || seen[d.id]) continue;
          seen[d.id] = 1; picks.push(d);
        }
        picks.forEach(function (d) { facts[String(d.id)] = factOf(d); factsJobs[String(d.id)] = Promise.resolve(); });
        var named = [topFood[0], topDrink[0]].filter(Boolean).map(function (c) { return c.toLowerCase(); });
        if (why) why.innerHTML = named.length ? 'Because you save and make ' + esc(named.join(' and ')) + '. New picks every Monday.'
          : '<button type="button" class="mk-link" data-mk-go="profile">Tell us what you love baking</button> to tailor these';
        box.innerHTML = picks.length ? picks.map(function (d) {
          var u = String(d.url || '').split('?')[0];
          return '<div class="mk-pick"><a href="' + esc(u) + '">' + thumb('recipe', 'Recipe', d.image_url ? sized(d.image_url, 400) : '') + '<strong>' + esc(d.title) + '</strong></a>' +
            '<span class="mk-facts">' + esc(factLine(d.id)) + '</span>' + planBtn(String(d.id), d.title, u, d.image_url || '') + '</div>';
        }).join('') : '<p class="mk-sub">Save a few recipes or tell us what you love baking and we\'ll suggest what to try next.</p>';
      });
    });
  }
  function drawPickedLegacy(force) {
    var box = root.querySelector('[data-mk-list="picked"]'), why = root.querySelector('[data-mk-picked-why]');
    if (!box || (box.getAttribute('data-done') && !force)) return;
    box.setAttribute('data-done', '1');
    var p = me.profile() || {}, rnd = seeded(weekNo * 97 + 13);
    var words = ((p.prefs || {}).goals || []).map(function (x) { return GOAL_WORD[x]; }).concat((p.loves || []).map(function (x) { return LOVE_WORD[x]; }))
      .concat((p.interests || []).map(function (x) { return SEARCH_WORD[x]; })).filter(Boolean);
    words = words.filter(function (w, i) { return words.indexOf(w) === i; });
    var named = (p.loves && p.loves.length ? p.loves : (p.interests || [])).slice(0, 2).map(function (x) { return x.replace('Cafe', 'Caf\u00e9').toLowerCase(); });
    if (!words.length) words = ['vanilla cake', 'cookies', 'pie', 'custard'];
    if (why) why.innerHTML = named.length ? 'Because you love ' + esc(named.join(' and ')) + '. New picks every Monday.'
      : '<button type="button" class="mk-link" data-mk-go="profile">Tell us what you love baking</button> to tailor these';
    var pick2 = [words[Math.floor(rnd() * words.length)], words[Math.floor(rnd() * words.length)]];
    var exclude = list(K.recipes).map(String).concat(Object.keys(list(K.bakes))).concat(Object.keys(list(K.plan)));
    box.innerHTML = '<p class="mk-sub">Finding recipes for you...</p>';
    Promise.all([suggest(pick2[0], 'article'), suggest(pick2[1], 'article')]).then(function (r) {
      var drinksOk = (p.loves || []).some(function (x) { return x === 'Cafe drinks' || x === 'Tea'; }) || (p.interests || []).some(function (x) { return /Coffee|Drinks/.test(x); });
      var seen = {}, pool = r[0].concat(r[1]).filter(function (a) {
        if (!/\/blogs\/recipes\//.test(a.url || '') || seen[a.id] || exclude.indexOf(String(a.id)) > -1) return false;
        if (!drinksOk && DRINK_RX.test(a.title || '')) return false;
        seen[a.id] = 1; return true;
      });
      for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)), t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
      var picks = pool.slice(0, 4);
      box.innerHTML = picks.length ? picks.map(function (a) {
        var u = String(a.url).split('?')[0];
        return '<div class="mk-pick"><a href="' + esc(u) + '">' + thumb('recipe', 'Recipe', a.image ? sized(a.image, 400) : '') + '<strong>' + esc(a.title) + '</strong></a>' +
          planBtn(String(a.id), a.title, u, a.image || '') + '</div>';
      }).join('') : '<p class="mk-sub">Save a few recipes or tell us what you love baking and we\'ll suggest what to try next.</p>';
    });
  }

  /* ---------- v3: Dessert Builder card on This week ---------- */
  function drawDessertsCard() {
    var box = root.querySelector('[data-mk-desserts-card]'); if (!box) return;
    var ds = list(K.desserts), all = Object.keys(ds), keys = all.sort(function (a, b) { return (ds[b].c || 0) - (ds[a].c || 0); }).slice(0, 3);
    var kind = { cake: 'Layer cake', cupcake: 'Cupcakes', pie: 'Pie', cheesecake: 'Cheesecake', doughnut: 'Doughnuts' };
    box.innerHTML = '<div class="mk-cardhead"><h2>Your desserts</h2>' + (all.length > 3 ? '<button type="button" class="mk-link" data-mk-go="desserts">All ' + all.length + '</button>' : '<span class="mk-sub">Dessert Builder</span>') + '</div>' +
      (keys.length ? keys.map(function (k) {
        var d = ds[k];
        return '<div class="mk-row">' + thumb('recipe', (kind[d.t] || 'D').charAt(0), d.i) + '<span class="mk-grow"><strong><a href="' + esc(d.u || '/pages/dessert-builder') + '">' + esc(d.n || 'Your dessert') + '</a></strong><span>' +
          esc((kind[d.t] || 'Dessert') + ' \u00b7 ' + ((d.p || '').split(',').filter(Boolean).length || 1) + ' parts') + '</span></span></div>';
      }).join('') : '<p class="mk-sub">Design a layer cake, cupcakes, a pie, a cheesecake or doughnuts from our tested recipes: one complete recipe, scaled, with a shopping list.</p>') +
      '<div class="mk-actions"><a class="mk-btn mk-btn--sm' + (keys.length ? '' : ' mk-btn--solid') + '" href="/pages/dessert-builder">' + (keys.length ? 'Build a new one' : 'Open the Dessert Builder') + '</a></div>';
  }

  /* ---------- v3: bakers you follow, from their public pages ---------- */
  var bakerCache = {};
  function bakerInfo(h) {
    if (bakerCache[h]) return bakerCache[h];
    bakerCache[h] = fetch('/pages/baker/' + encodeURIComponent(h)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var m = /<script type="application\/json" data-vg-baker-json>([\s\S]*?)<\/script>/.exec(html);
      try { return m ? JSON.parse(m[1]) : null; } catch (e) { return null; }
    }).catch(function () { return null; });
    return bakerCache[h];
  }
  function drawFollowCard() {
    var box = root.querySelector('[data-mk-follow-card]'); if (!box) return;
    var f = list('vg_follows_v1') || {}, all = Object.keys(f), hs = all.sort(function (a, b) { return String(f[b].d || '').localeCompare(String(f[a].d || '')); }).slice(0, 4);
    if (!hs.length) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = '<div class="mk-cardhead"><h2>Bakers you follow</h2><button type="button" class="mk-link" data-mk-go="public">All ' + all.length + '</button></div>' + hs.map(function (h) {
      var x = f[h] || {};
      return '<div class="mk-row" data-mk-baker="' + esc(h) + '"><span class="mk-avatar mk-avatar--sm">' + (x.p ? '<img src="' + esc(x.p) + '" alt="" width="36" height="36">' : esc(x.ini || '?')) + '</span>' +
        '<span class="mk-grow"><strong><a href="/pages/baker/' + esc(h) + '">' + esc(x.n || h) + '</a></strong><span data-mk-baker-line>Looking in on their kitchen...</span></span></div>';
    }).join('');
    hs.forEach(function (h) {
      bakerInfo(h).then(function (b) {
        var row = box.querySelector('[data-mk-baker="' + h.replace(/"/g, '') + '"] [data-mk-baker-line]'); if (!row) return;
        var since = ymd(new Date(NOW.getTime() - 7 * 86400000));
        var recent = (b && Array.isArray(b.bakes) ? b.bakes : []).filter(function (r) { return r && r.d && r.u; }).sort(function (a, c) { return String(c.d).localeCompare(String(a.d)); });
        var week = recent.filter(function (r) { return r.d >= since; });
        row.innerHTML = !b ? 'Profile not shared right now'
          : week.length ? 'Made ' + week.slice(0, 2).map(function (r) { return '<a href="' + esc(r.u) + '">' + esc(r.n) + '</a>'; }).join(' and ') + ' this week'
          : recent.length ? 'Last made <a href="' + esc(recent[0].u) + '">' + esc(recent[0].n) + '</a> on ' + esc(shortDay(recent[0].d))
          : (b.bakes_n ? b.bakes_n + ' bakes logged' : 'No bakes shared yet');
      });
    });
  }

  /* ---------- v3: saved podcasts (saved on the podcast hub into the Academy's saved list) ---------- */
  function drawPodcasts(st) {
    var box = root.querySelector('[data-mk-list="podcasts"]');
    var keys = Object.keys(st.saved).filter(function (k) { return /^(show|podcast):/.test(k); })
      .sort(function (a, b) { return (st.saved[b].t || 0) - (st.saved[a].t || 0); });
    setCount('podcasts', keys.length);
    if (!box) return keys.length;
    box.innerHTML = keys.length ? keys.map(function (k) {
      var it = st.saved[k] || {};
      return tile('', '<span class="mk-thumb mk-t-lesson">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : 'Podcast') + '</span>',
        '<strong><a href="' + esc(it.url || '/pages/baking-podcasts') + '">' + esc(it.title || 'Saved podcast') + '</a></strong><span>' + esc(it.sub || 'Baking podcast') + '</span>',
        '<a class="mk-btn mk-btn--sm mk-btn--solid" href="' + esc(it.url || '/pages/baking-podcasts') + '">Listen</a>' + removeLink('saved', k));
    }).join('') : emptyMsg('Tap "Save to My Kitchen" on any show in Baking Podcasts and it will wait for you here.', '/pages/baking-podcasts', 'Browse podcasts');
    return keys.length;
  }

  /* ---------- Pastry Pets (breeds, ingredients, guides saved on Pastry Pets pages into the same saved list as pet:<type>:<handle>) ---------- */
  function drawPets(st) {
    var box = root.querySelector('[data-mk-list="pets"]'), hub = '/pages/pastry-pets';
    var keys = Object.keys(st.saved).filter(function (k) { return k.indexOf('pet:') === 0; })
      .sort(function (a, b) { return (st.saved[b].t || 0) - (st.saved[a].t || 0); });
    setCount('pets', keys.length);
    if (!box) return keys.length;
    box.innerHTML = keys.length ? keys.map(function (k) {
      var it = st.saved[k] || {};
      return tile('', '<span class="mk-thumb mk-t-tool">' + esc((it.title || 'P').charAt(0)) + '</span>',
        '<strong><a href="' + esc(it.url || hub) + '">' + esc(it.title || 'Pastry Pets page') + '</a></strong><span>' + esc((it.sub || 'Pastry Pets') + ' · Pastry Pets') + '</span>',
        '<a class="mk-btn mk-btn--sm mk-btn--solid" href="' + esc(it.url || hub) + '">Open</a>' + removeLink('saved', k));
    }).join('') : emptyMsg('Tap "Save to My Kitchen" on any dog breed, ingredient or guide in Pastry Pets and it will wait for you here.', hub, 'Open Pastry Pets');
    return keys.length;
  }

  /* ---------- v3: shopping list for the week (ingredients from each planned recipe's JSON view) ---------- */
  var SHOP = 'vg_shop_v1', recipeCache = {}, shopLines = [];
  function recipeJson(u) {
    var k = urlKey(u);
    if (!recipeCache[k]) recipeCache[k] = fetch(k + '?view=vgb').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return recipeCache[k];
  }
  var UNIT = { cup: 'cup', cups: 'cup', c: 'cup', tbsp: 'tbsp', tablespoon: 'tbsp', tablespoons: 'tbsp', tsp: 'tsp', teaspoon: 'tsp', teaspoons: 'tsp',
               g: 'g', gram: 'g', grams: 'g', ml: 'ml', oz: 'oz', 'fl oz': 'fl oz', lb: 'lb', lbs: 'lb' };
  function ingKey(name) {
    return String(name || '').toLowerCase().replace(/\([^)]*\)/g, '').split(',')[0]
      .replace(/\b(cold|softened|melted|room temperature|divided|plus more|for dusting|to taste|chopped|sifted|packed|ripe|fresh|whole|cubed)\b/g, '')
      .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function fmtAmount(n, unit) {
    if (!n) return '';
    if (unit === 'g' || unit === 'ml') return String(Math.round(n));
    var whole = Math.floor(n + 1e-6), frac = n - whole, best = '', bd = 0.07;
    [[0.125, '\u215b'], [0.25, '\u00bc'], [0.333, '\u2153'], [0.375, '\u215c'], [0.5, '\u00bd'], [0.625, '\u215d'], [0.667, '\u2154'], [0.75, '\u00be'], [0.875, '\u215e']]
      .forEach(function (f) { var d = Math.abs(frac - f[0]); if (d < bd) { bd = d; best = f[1]; } });
    if (frac >= 0.93) { whole += 1; best = ''; }
    else if (!best && frac > 0.07) return String(Math.round(n * 100) / 100);
    return ((whole ? String(whole) : '') + (whole && best ? ' ' : '') + best) || '0';
  }
  function shopCategory(name) {
    var n = name.toLowerCase();
    if (/butter(?! ?(scotch|nut))|cream|milk|egg|yogurt|cheese|half-and-half/.test(n)) return 'Dairy and eggs';
    if (/apple|lemon|lime|orange|banana|berr|peach|pear|pumpkin|mango|pineapple|cherr|fig|dates|zucchini|carrot|mint|avocado|cucumber/.test(n)) return 'Produce';
    if (/flour|sugar|baking (powder|soda)|salt|yeast|cornstarch|oat|cocoa|chocolate|vanilla|extract|honey|maple|molasses|syrup|nut|almond|pecan|walnut|pistachio|coconut|raisin|cinnamon|nutmeg|cardamom|spice|clove|ginger|gelatin/.test(n)) return 'Baking aisle';
    if (/coffee|espresso|tea|matcha|chai|cold brew|\bice\b|soda|water/.test(n)) return 'Drinks';
    return 'Other';
  }
  function shopAll() { try { return JSON.parse(window.localStorage.getItem(SHOP) || '{}') || {}; } catch (e) { return {}; } }
  function shopState() { return shopAll()[weekStart] || {}; }
  function shopMark(key, on) {
    var w = shopState(); if (on) w[key] = 1; else delete w[key];
    var next = {}; next[weekStart] = w;
    try { window.localStorage.setItem(SHOP, JSON.stringify(next)); } catch (e) { /* blocked */ }
  }
  function drawShop() {
    var card = root.querySelector('[data-mk-shop]'), body = root.querySelector('[data-mk-shop-body]'), sub = root.querySelector('[data-mk-shop-sub]');
    if (!card || !body) return;
    var rows = planEntries().filter(function (x) { return !x.p.x && x.p.u; });
    card.hidden = false;
    if (!rows.length) { body.innerHTML = '<p class="mk-empty">Add recipes to your bake list and their ingredients are combined here.</p>'; if (sub) sub.textContent = ''; shopLines = []; return; }
    body.innerHTML = '<p class="mk-sub">Reading ' + rows.length + ' recipe' + (rows.length === 1 ? '' : 's') + '...</p>';
    var grams = ((me.profile() || {}).prefs || {}).units === 'grams';
    Promise.all(rows.map(function (x) { return recipeJson(x.p.u).then(function (j) { return { x: x, j: j }; }); })).then(function (all) {
      var agg = {}, order = [], missing = [];
      all.forEach(function (it) {
        if (!it.j || !it.j.ingredients) { missing.push(it.x.p.n); return; }
        it.j.ingredients.forEach(function (ing) {
          if (!ing || !ing.name || ing.heading) return;
          var metric = grams && ing.amount_metric && ing.unit_metric;
          var amt = Number(metric ? ing.amount_metric : ing.amount) || 0, unit = String((metric ? ing.unit_metric : ing.unit) || '').toLowerCase().trim();
          unit = UNIT[unit] || unit;
          var key = ingKey(ing.name) + '|' + unit;
          if (!agg[key]) { agg[key] = { name: String(ing.name).split(',')[0].trim(), unit: unit, amt: 0, from: [], cat: shopCategory(ing.name) }; order.push(key); }
          agg[key].amt += amt;
          if (agg[key].from.indexOf(it.x.p.n) < 0) agg[key].from.push(it.x.p.n);
        });
      });
      var done = shopState(), cats = {};
      order.forEach(function (k) { var c = agg[k].cat; (cats[c] = cats[c] || []).push(k); });
      var catOrder = ['Produce', 'Dairy and eggs', 'Baking aisle', 'Drinks', 'Other'].filter(function (c) { return cats[c]; });
      shopLines = [];
      body.innerHTML = catOrder.map(function (c) {
        return '<h3 class="mk-shop-h">' + esc(c) + '</h3><ul class="mk-shop-list">' + cats[c].map(function (k) {
          var a = agg[k], unitWord = (a.unit === 'cup' || a.unit === 'lb') && a.amt > 1 ? a.unit + 's' : a.unit;
          var q = (fmtAmount(a.amt, a.unit) + ' ' + unitWord).trim(), line = (q ? q + ' ' : '') + a.name;
          shopLines.push((done[k] ? '[x] ' : '[ ] ') + line);
          var vanilla = /vanilla/i.test(a.name) ? ' <a class="mk-link" href="/collections/vanilla-extracts">Shop vanilla</a>' : '';
          return '<li' + (done[k] ? ' class="is-done"' : '') + '><label><input type="checkbox" data-mk-shop-tick="' + esc(k) + '"' + (done[k] ? ' checked' : '') + '> <span>' + esc(line) + '</span></label><small>' + esc(a.from.join(', ')) + '</small>' + vanilla + '</li>';
        }).join('') + '</ul>';
      }).join('') + (missing.length ? '<p class="mk-note">Could not read ' + esc(missing.join(', ')) + '; check those on the recipe page.</p>' : '');
      if (sub) sub.textContent = rows.length + ' recipe' + (rows.length === 1 ? '' : 's') + ' \u00b7 ' + order.length + ' items' + (grams ? ' \u00b7 in grams' : '');
      var share = root.querySelector('[data-mk-shop-share]'); if (share) share.hidden = !navigator.share;
      track('shopping_list', { recipes: rows.length, items: order.length });
    });
  }
  function shopText() { return 'Shopping list, week of ' + shortDay(weekStart) + ' (VanillaGoods My Kitchen)\n\n' + shopLines.join('\n'); }
  function openShop() {
    go('bakes', true);
    drawShop();
    var card = root.querySelector('[data-mk-shop]');
    if (card) setTimeout(function () { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-mk-shop-tick')) {
      shopMark(t.getAttribute('data-mk-shop-tick'), t.checked);
      var li = t.closest('li'); if (li) li.classList.toggle('is-done', t.checked);
      var text = li ? li.querySelector('label span').textContent : '';
      shopLines = shopLines.map(function (l) { return l.slice(4) === text ? (t.checked ? '[x] ' : '[ ] ') + text : l; });
    }
  });

  /* ---------- This week header line ---------- */
  function drawHero(planInfo) {
    var wk = root.querySelector('[data-mk-weekof]');
    if (wk) wk.textContent = 'Week of ' + monday.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    var line = root.querySelector('[data-mk-hero-line]'), st = academyState(), bits = [];
    if (!line) return;
    if (planInfo.todo) bits.push(planInfo.todo + ' recipe' + (planInfo.todo === 1 ? '' : 's') + ' on your bake list');
    else if (planInfo.rows.length) bits.push('everything on your bake list is baked');
    if (st.cur) bits.push((st.cur.n - st.cur.done) + ' lesson' + (st.cur.n - st.cur.done === 1 ? '' : 's') + ' left in ' + st.cur.c.n);
    var ev = upcomingEvents()[0];
    if (ev && ev.s && ev.s <= ymd(new Date(NOW.getTime() + 14 * 86400000))) bits.push(ev.name + ' on ' + shortDay(ev.s));
    line.textContent = bits.length ? 'This week: ' + bits.join(', ') + '.' : 'Plan a bake or two, join this week\'s bake-along, or try one of your picks.';
  }

  /* ---------- round 1 (Oct 2026): weekly baking rhythm, yearly goal, profile meter, a question or two at a time ---------- */
  function mondayOf(d) {
    var dt = new Date(String(d).slice(0, 10) + 'T12:00:00');
    if (isNaN(dt)) return '';
    dt.setDate(dt.getDate() - ((dt.getDay() + 6) % 7));
    return ymd(dt);
  }
  function bakeDates() {
    var bakes = list(K.bakes), out = [];
    Object.keys(bakes).forEach(function (k) {
      var b = bakes[k] || {};
      if (b.h) String(b.h).split(',').forEach(function (d) { if (/^\d{4}-\d{2}-\d{2}$/.test(d)) out.push(d); });
      else if (b.d) out.push(String(b.d).slice(0, 10));
    });
    return out;
  }
  function bakeWeeks() {
    var seen = {};
    bakeDates().forEach(function (d) { var w = mondayOf(d); if (w) seen[w] = true; });
    return Object.keys(seen).sort();
  }
  function yearBakes() {
    var y = String(NOW.getFullYear()), bakes = list(K.bakes), n = 0;
    Object.keys(bakes).forEach(function (k) {
      var b = bakes[k] || {};
      if (b.h) n += String(b.h).split(',').filter(function (d) { return d.slice(0, 4) === y; }).length;
      else if (String(b.d || '').slice(0, 4) === y) n += Number(b.c) || 1;
    });
    return n;
  }
  function drawRhythm() {
    var box = root.querySelector('[data-mk-rhythm]');
    if (!box) return;
    var weeks = bakeWeeks(), have = {}, i, run = 0, cells = [];
    weeks.forEach(function (w) { have[w] = true; });
    var start = new Date(monday);
    for (i = 7; i >= 0; i--) {
      var d = new Date(start); d.setDate(start.getDate() - 7 * i);
      var key = ymd(d), on = !!have[key];
      cells.push('<li class="mk-wk' + (on ? ' is-on' : '') + (i === 0 ? ' is-now' : '') + '" title="Week of ' + esc(shortDay(key)) + (on ? ': baked' : '') + '"><span>' +
        esc(d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })) + '</span></li>');
    }
    // the run counts back from this week, or from last week if this week has no bake yet (a quiet week never "breaks" anything)
    var probe = new Date(monday); if (!have[ymd(probe)]) probe.setDate(probe.getDate() - 7);
    while (have[ymd(probe)]) { run++; probe.setDate(probe.getDate() - 7); }
    var thisWeek = !!have[weekStart];
    var line = run > 1 ? 'You\'ve baked ' + run + ' weeks in a row. Nice rhythm.'
      : thisWeek ? 'You baked this week. Every bake counts.'
      : weeks.length ? 'Bake anything this week to add it to your rhythm.' : 'Log a bake from any recipe and your baking weeks show here.';
    var goal = Number((me.profile() || {}).goal) || 0, yb = yearBakes();
    var goalHtml = goal
      ? '<div class="mk-goal"><div class="mk-goal-top"><strong>' + yb + ' of ' + goal + ' bakes in ' + NOW.getFullYear() + '</strong><span>' + Math.min(100, Math.round(100 * yb / goal)) + '%</span></div>' +
        '<span class="mk-bar mk-bar--gold" role="img" aria-label="' + yb + ' of ' + goal + ' bakes"><i style="width:' + Math.min(100, Math.round(100 * yb / goal)) + '%"></i></span></div>'
      : '<p class="mk-sub">' + yb + ' bake' + (yb === 1 ? '' : 's') + ' logged in ' + NOW.getFullYear() + '. <button type="button" class="mk-link" data-mk-go="profile" data-mk-focus="mk-p-goal">Set a yearly goal</button></p>';
    box.innerHTML = '<div class="mk-cardhead"><h2>Your baking rhythm</h2><span class="mk-sub">Last 8 weeks</span></div>' +
      '<ol class="mk-weeks" aria-label="Weeks you baked">' + cells.join('') + '</ol><p class="mk-rhythm-line">' + esc(line) + '</p>' + goalHtml;
  }

  var ASK = [
    { k: 'units', q: 'How do you like to measure?', why: 'So recipes open in cups or grams the way you bake.' },
    { k: 'oven', q: 'What kind of oven do you bake in?', why: 'Convection and countertop ovens need different times. We\'ll flag it on recipes.' },
    { k: 'often', q: 'How often do you bake?', why: 'So your weekly picks match how much time you have.' },
    { k: 'bakefor', q: 'Who do you usually bake for?', why: 'So we suggest the right batch sizes.' },
    { k: 'time', q: 'How much time do you have on a weeknight?', why: 'So weeknight picks fit your evening.' },
    { k: 'altitude', q: 'What altitude do you bake at?', why: 'Above 3,000 ft, cakes and breads need small changes. We\'ll point them out.' },
    { k: 'sweet', q: 'How sweet do you like things?', why: 'So we can suggest lighter or richer versions.' }
  ];
  function drawAsk() {
    var box = root.querySelector('[data-mk-ask]');
    if (!box || !pform) return;
    var pr = (me.profile() || {}).prefs || {};
    var open = ASK.filter(function (a) { var s = root.querySelector('[data-mk-pick="' + a.k + '"]'); return s && !pr[a.k] && !s.value; }).slice(0, 2);
    var meter = profileMeter();
    if (!open.length) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = '<div class="mk-cardhead"><h2>Tailor your kitchen</h2><span class="mk-sub">Profile ' + meter.pct + '% \u00b7 ' + esc(meter.level) + '</span></div>' +
      open.map(function (a) {
        var src = root.querySelector('[data-mk-pick="' + a.k + '"]');
        return '<label class="mk-askq">' + esc(a.q) + '<select data-mk-ask-pick="' + a.k + '">' + src.innerHTML + '</select><small>' + esc(a.why) + '</small></label>';
      }).join('') + '<p class="mk-form-msg" data-mk-ask-msg role="status" aria-live="polite"></p>';
    box.querySelectorAll('select').forEach(function (s) { s.value = ''; });
  }
  function profileMeter() {
    var p = me.profile() || {}, pr = p.prefs || {};
    var v = function (id) { var el = field(id); return el ? String(el.value || '').trim() : ''; };
    var items = [
      { n: 'Joined My Kitchen', done: true },
      { n: 'Display name', done: !!(p.name || v('mk-p-name')), f: 'mk-p-name' },
      { n: 'Photo or baking icon', done: !!(p.avatar && p.avatar.kind && p.avatar.kind !== 'initials'), f: 'mk-photo' },
      { n: 'Skill level', done: !!(p.skill), f: 'mk-skill' },
      { n: 'Where you bake', done: !!(p.city || p.state || p.region), f: 'mk-p-city' },
      { n: 'About you', done: !!(p.bio), f: 'mk-p-bio' },
      { n: 'Baking since', done: !!(p.bakingSince), f: 'mk-p-since' },
      { n: 'Signature bake', done: !!(p.signature), f: 'mk-p-sig' },
      { n: 'Favorite vanilla', done: !!(p.vanilla), f: 'mk-p-vanilla' },
      { n: 'Go-to flavors', done: !!(p.flavors && p.flavors.length) },
      { n: 'Top 5 recipes', done: !!(p.top5 && p.top5.length) },
      { n: 'Measurements', done: !!(pr.units), f: 'mk-f-units' },
      { n: 'Your oven', done: !!(pr.oven), f: 'mk-f-oven' },
      { n: 'Baking goals', done: !!(pr.goals && pr.goals.length) }
    ];
    var got = items.filter(function (x) { return x.done; }).length, pct = Math.round(100 * got / items.length);
    var level = pct >= 100 ? 'Blue ribbon' : pct >= 70 ? 'Golden' : pct >= 35 ? 'Rising' : 'Proofing';
    return { items: items, pct: pct, level: level, next: items.filter(function (x) { return !x.done; }) };
  }
  function drawMeter() {
    var box = root.querySelector('[data-mk-meter]');
    if (!box) return;
    var m = profileMeter(), lv = ['Proofing', 'Rising', 'Golden', 'Blue ribbon'];
    box.innerHTML = '<div class="mk-meter-top"><div><p class="mk-eyebrow">Your profile</p><h2>' + m.pct + '% \u00b7 ' + esc(m.level) + '</h2></div>' +
      '<ol class="mk-levels">' + lv.map(function (l) { return '<li' + (l === m.level ? ' class="is-on"' : '') + '>' + l + '</li>'; }).join('') + '</ol></div>' +
      '<span class="mk-bar mk-bar--gold" role="img" aria-label="Profile ' + m.pct + '% complete"><i style="width:' + m.pct + '%"></i></span>' +
      (m.next.length ? '<p class="mk-sub">Next: ' + m.next.slice(0, 3).map(function (x) {
        return x.f ? '<button type="button" class="mk-link" data-mk-focus="' + x.f + '">' + esc(x.n) + '</button>' : esc(x.n);
      }).join(', ') + '. Members who finish their profile get picks that fit how they bake.</p>' : '<p class="mk-sub">Your profile is complete. Thank you!</p>');
  }
  function drawRound1() { drawRhythm(); drawMeter(); drawAsk(); drawCollections(); drawFollows(); }

  /* postal code fills city and region (zippopotam.us, free); only after the member types a valid code */
  var ZIP_OK = { US: 1, CA: 1, GB: 1, AU: 1, DE: 1, FR: 1, ES: 1, IT: 1, IN: 1, MX: 1, NL: 1, JP: 1, BR: 1, NZ: 1, BE: 1, CH: 1, AT: 1, PL: 1, PT: 1, SE: 1, NO: 1, DK: 1, FI: 1 };
  function zipKey(c, val) {
    val = val.trim().toUpperCase();
    if (c === 'CA') return val.replace(/\s/g, '').slice(0, 3);
    if (c === 'GB') return val.indexOf(' ') > -1 ? val.split(' ')[0] : val.slice(0, -3);
    if (c === 'NL') return val.replace(/\s/g, '').slice(0, 4);
    if (c === 'BR') return val.replace('-', '');
    if (c === 'US') return val.slice(0, 5);
    return val;
  }
  function postalFill() {
    var sel = field('mk-p-country'), pi = field('mk-p-postal');
    if (!sel || !pi || !pi.value.trim() || !checkPostal()) return;
    var c = sel.value || 'US';
    if (!ZIP_OK[c] || !window.fetch) return;
    fetch('https://api.zippopotam.us/' + c.toLowerCase() + '/' + encodeURIComponent(zipKey(c, pi.value)))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var pl = d && d.places && d.places[0];
        if (!pl || sel.value !== c) return;
        var city = field('mk-p-city');
        if (city && !city.value.trim() && pl['place name']) city.value = pl['place name'];
        if (c === 'US') { var st = field('mk-p-state'); if (st && !st.value && pl['state abbreviation']) st.value = pl['state abbreviation']; }
        else { var rg = field('mk-p-region'); if (rg && !rg.value.trim()) rg.value = pl['state abbreviation'] && c === 'CA' ? pl['state abbreviation'] : (pl.state || ''); }
      })['catch'](function () { /* the member can type it */ });
  }

  function drawAll() {
    var st = academyState();
    var nP = drawProducts(), nB = drawBooks(), nT = drawTools(); drawDesserts(); drawBaskets(); drawBakes();
    var nM = drawMarkets();
    var a = drawArticles(), ev = drawEvents();
    drawAcademy(st);
    var nPod = drawPodcasts(st), nPet = drawPets(st);
    drawDessertsCard(); drawBasketsCard(); drawFollowCard(); drawBakeBudget(); drawBakeBudgetCard();
    var subs = drawSubmissions(), revs = drawReviews();
    setCount('saved-all', a.recipes.length + a.journal.length + nP + nB + nT + nPod + nPet);
    setCount('shared', subs.length + revs.length);
    setCount('out', ev.length + nM);
    var planInfo = drawPlan();
    drawAlong();
    drawMilestones(st);
    drawRound1();
    drawHero(planInfo);
    drawSideProfile();
    drawPicked(false);
    if (root.querySelector('[data-mk-panel="public"].is-on')) drawPublic();
  }

  /* ---------- actions ---------- */
  function addToCart(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); });
  }
  function removeFrom(kind, key) {
    var k = K[kind], v = list(k);
    if (Array.isArray(v)) v = v.filter(function (x) { return String(x) !== String(key); });
    else delete v[key];
    me.set(k, v);
  }
  function copyText(text, okMsg) {
    var done = function () { toast(okMsg); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { window.prompt('Copy this link:', text); });
    else window.prompt('Copy this link:', text);
  }

  root.addEventListener('click', function (e) {
    var g = e.target.closest('[data-mk-go]');
    if (g) { e.preventDefault(); go(g.getAttribute('data-mk-go'), true); return; }
    if (e.target.closest('[data-mk-sheet]')) { openSheet(); return; }
    if (e.target.closest('[data-mk-sheet-close]') || e.target === sheet) { closeSheet(); return; }
    var tb = e.target.closest('[data-mk-tab]');
    if (tb) { showTab(tb.getAttribute('data-mk-tab')); return; }
    var sg = e.target.closest('[data-mk-seg-pick]');
    if (sg) {
      var segName = sg.closest('[data-mk-seg]').getAttribute('data-mk-seg');
      seg[segName] = sg.getAttribute('data-mk-seg-pick');
      if (segName === 'recipes') drawArticles(); else drawBakes();
      track('saved_filter', { list: segName, show: seg[segName] });
      return;
    }
    if (e.target.closest('[data-mk-shop-open]')) { openShop(); return; }
    if (e.target.closest('[data-mk-shop-copy]')) { copyText(shopText(), 'Shopping list copied.'); return; }
    if (e.target.closest('[data-mk-shop-share]')) { if (navigator.share) navigator.share({ title: 'Shopping list', text: shopText() }).catch(function () { /* closed */ }); return; }
    if (e.target.closest('[data-mk-shop-clear]')) { var nx = {}; nx[weekStart] = {}; try { window.localStorage.setItem(SHOP, JSON.stringify(nx)); } catch (err) { /* blocked */ } drawShop(); return; }
    if (e.target.closest('[data-mk-shop-print]')) {
      var w = window.open('', '_blank');
      if (!w) { toast('Allow pop-ups for this site to print the list.'); return; }
      w.document.write('<!doctype html><html><head><meta charset="utf-8"><title>Shopping list</title><style>body{font:16px/1.5 Georgia,serif;color:#2f2118;margin:32px;max-width:640px}h1{font-size:22px}li{list-style:none;margin:4px 0}li:before{content:"[ ] "}li.x:before{content:"[x] "}small{color:#6b5444}button{margin-top:16px}</style></head><body><h1>Shopping list, week of ' + esc(shortDay(weekStart)) + '</h1><ul>' +
        shopLines.map(function (l) { return '<li' + (l.indexOf('[x]') === 0 ? ' class="x"' : '') + '>' + esc(l.slice(4)) + '</li>'; }).join('') + '</ul><small>vanillagoods.com/pages/my-kitchen</small><br><button onclick="window.print()">Print</button></body></html>');
      w.document.close();
      return;
    }
    var tk = e.target.closest('[data-mk-tick]');
    if (tk) { tick(tk.getAttribute('data-mk-tick')); return; }
    var pr = e.target.closest('[data-mk-plan-remove]');
    if (pr) { var pl = list(K.plan); delete pl[pr.getAttribute('data-mk-plan-remove')]; me.set(K.plan, pl); drawAll(); return; }
    var pa = e.target.closest('[data-mk-plan-add]');
    if (pa) {
      var on = planToggle(pa.getAttribute('data-mk-plan-add'), pa.getAttribute('data-n'), pa.getAttribute('data-u'), pa.getAttribute('data-i'));
      pa.setAttribute('aria-pressed', on ? 'true' : 'false'); pa.classList.toggle('is-on', on); pa.textContent = on ? 'On my week' : 'Add to my week';
      drawPlan(); drawAlong();
      if (on) toast('Added to your week. <button type="button" class="mk-link" data-mk-go="week">See your bake list</button>');
      return;
    }
    var aa = e.target.closest('[data-mk-along-add]');
    if (aa) { aa.disabled = true; addByUrl(aa.getAttribute('data-mk-along-add'), aa.getAttribute('data-n'), aa.getAttribute('data-i')); return; }
    var ch = e.target.closest('[data-mk-chip], [data-mk-interest]');
    if (ch) {
      var box = ch.parentNode, onNow = ch.getAttribute('aria-pressed') === 'true';
      var capped = /^(flavors|loves)$/.test(box.getAttribute('data-mk-chips') || '');
      if (!onNow && capped && box.querySelectorAll('[aria-pressed="true"]').length >= 8) { toast('Pick up to 8.'); return; }
      ch.setAttribute('aria-pressed', String(!onNow));
      return;
    }
    var tg = e.target.closest('.mk-tog');
    if (tg) { setTog(tg, !isOn(tg)); updateHints(); return; }
    var ic = e.target.closest('[data-mk-icon]');
    if (ic) { draft.avatar = { kind: 'icon', icon: ic.getAttribute('data-mk-icon'), color: draft.avatar.color || 'gold' }; drawIcons(); paintAvatars(draft.avatar, me.profile() || {}); return; }
    var co = e.target.closest('[data-mk-color]');
    if (co) {
      draft.avatar.color = co.getAttribute('data-mk-color');
      if (draft.avatar.kind === 'photo') draft.avatar.kind = draft.avatar.icon ? 'icon' : 'initials';
      drawIcons(); paintAvatars(draft.avatar, me.profile() || {}); return;
    }
    if (e.target.closest('[data-mk-av-initials]')) { draft.avatar = { kind: 'initials', icon: '', color: draft.avatar.color || 'gold' }; drawIcons(); paintAvatars(draft.avatar, me.profile() || {}); return; }
    var t5p = e.target.closest('[data-mk-t5-pick]');
    if (t5p) {
      if (draft.top5.length < 5) draft.top5.push({ id: t5p.getAttribute('data-mk-t5-pick'), n: t5p.getAttribute('data-n'), u: t5p.getAttribute('data-u'), i: t5p.getAttribute('data-i') });
      drawTop5(); return;
    }
    var up = e.target.closest('[data-mk-t5-up]'), dn = e.target.closest('[data-mk-t5-down]'), x = e.target.closest('[data-mk-t5-x]');
    if (up || dn) {
      var i = Number((up || dn).getAttribute(up ? 'data-mk-t5-up' : 'data-mk-t5-down')), j = up ? i - 1 : i + 1;
      if (j >= 0 && j < draft.top5.length) { var t = draft.top5[i]; draft.top5[i] = draft.top5[j]; draft.top5[j] = t; drawTop5(); }
      return;
    }
    if (x) { draft.top5.splice(Number(x.getAttribute('data-mk-t5-x')), 1); drawTop5(); return; }
    var sp = e.target.closest('[data-mk-share-profile]');
    if (sp) {
      var u = (me.profile() || {}).url;
      if (!u) return;
      if (navigator.share && window.innerWidth < 990) navigator.share({ title: 'My baking on VanillaGoods', url: u }).catch(function () { /* closed */ });
      else copyText(u, 'Profile link copied.');
      track('profile_share', {});
      return;
    }
    if (e.target.closest('[data-mk-open-form]')) {
      if (form) { form.hidden = false; var tt = form.querySelector('#mk-r-title'); if (tt) tt.focus(); }
      return;
    }
    if (e.target.closest('[data-mk-close-form]')) { if (form) { form.hidden = true; formMsg(''); } return; }
    var cert = e.target.closest('[data-mk-cert]');
    if (cert) { printCertificate(cert.getAttribute('data-mk-cert')); return; }
    var rm = e.target.closest('[data-mk-remove]');
    if (rm) { removeFrom(rm.getAttribute('data-mk-remove'), rm.getAttribute('data-key')); drawAll(); toast('Removed'); return; }
    var re = e.target.closest('[data-mk-reorder]');
    if (re) {
      var items = []; try { items = JSON.parse(re.getAttribute('data-items') || '[]'); } catch (err) { items = []; }
      if (!items.length) { toast('Everything in this order is sold out right now.'); return; }
      re.disabled = true;
      addToCart(items).then(function () {
        track('reorder', { order: re.getAttribute('data-mk-reorder'), items: items.length });
        window.location.href = '/cart';
      }).catch(function (err) { re.disabled = false; toast(esc(err.message)); });
      return;
    }
    var buy = e.target.closest('[data-mk-buy], [data-mk-add]');
    if (buy) {
      var id = buy.getAttribute('data-mk-buy') || buy.getAttribute('data-variant');
      if (!id) return;
      buy.disabled = true;
      addToCart([{ id: Number(id), quantity: Number(buy.getAttribute('data-qty') || 1) }]).then(function () {
        buy.disabled = false; toast('Added to your cart <a href="/cart">View cart</a>');
      }).catch(function (err) { buy.disabled = false; toast(esc(err.message)); });
      return;
    }
    var cp = e.target.closest('[data-mk-copy]');
    if (cp) {
      var code = cp.getAttribute('data-mk-copy');
      var done = function () { cp.textContent = 'Copied'; toast('Code ' + esc(code) + ' copied. Use it at checkout.'); setTimeout(function () { cp.textContent = 'Copy code'; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
      track('welcome_code_copy', {});
      return;
    }
    var all = e.target.closest('[data-mk-all-to-cart]');
    if (all) {
      var vs = Array.prototype.map.call(root.querySelectorAll('[data-mk-add][data-variant]'), function (b) { return { id: Number(b.getAttribute('data-variant')), quantity: 1 }; });
      if (!vs.length) { toast('None of your saved products are in stock right now.'); return; }
      all.disabled = true;
      addToCart(vs).then(function () { window.location.href = '/cart'; }).catch(function (err) { all.disabled = false; toast(esc(err.message)); });
    }
  });
  // the toast lives outside the dashboard
  document.addEventListener('click', function (e) {
    var g = e.target.closest('.mk-toast [data-mk-go]');
    if (g) { e.preventDefault(); go(g.getAttribute('data-mk-go'), true); }
  });

  /* ---------- just signed in from another page: welcome them and offer the way back ---------- */
  (function welcome() {
    var from = null;
    try { from = JSON.parse(window.sessionStorage.getItem('vg_join_from') || 'null'); window.sessionStorage.removeItem('vg_join_from'); } catch (e) { from = null; }
    var panel = root.querySelector('[data-mk-panel="week"]');
    if (!from || !from.u || from.u.charAt(0) !== '/' || !panel) return;
    var box = document.createElement('div');
    box.className = 'mk-welcome';
    box.setAttribute('role', 'status');
    box.innerHTML = '<span><strong>You\'re signed in.</strong> Anything you saved is in My Kitchen now, and it follows you to every device.</span>' +
      '<a class="mk-btn mk-btn--sm" href="' + esc(from.u) + '">Back to ' + esc((from.t || 'where you were').slice(0, 60)) + '</a>' +
      '<button type="button" class="mk-link" data-mk-welcome-close>Close</button>';
    box.querySelector('[data-mk-welcome-close]').addEventListener('click', function () { box.remove(); });
    panel.insertBefore(box, panel.firstChild);
    track('join_welcome', {});
  })();

  (function visits() {
    var n = 0;
    try {
      n = Number(window.localStorage.getItem('vg_mk_visits')) || 0;
      if (!window.sessionStorage.getItem('vg_mk_seen')) { n += 1; window.localStorage.setItem('vg_mk_visits', String(n)); window.sessionStorage.setItem('vg_mk_seen', '1'); }
    } catch (e) { n = 0; }
    if (n > 3 && !(Number((me.profile() || {}).invites) > 0)) root.classList.add('mk-invite-slim');
  })();
  baseInitials = ((root.querySelector('[data-mk-avatar]') || {}).textContent || '').trim();
  loadProfileForm();
  me.onChange(drawAll);
  drawAll();
  var hash = location.hash.replace('#', '');
  if (hash) go(hash, false);
})();
